export default {
  "Hair": {
    "parts": [
      {
        "value": null,
        "displayName": "None",
        "excludeFromRandomize": false
      },
      {
        "value": "hair_aLine-asym-black",
        "displayName": "ALine Asym Black",
        "description": {
          "Type": "aLine-asym",
          "Color": "black"
        }
      },
      {
        "value": "hair_aLine-asym-blonde",
        "displayName": "ALine Asym Blonde",
        "description": {
          "Type": "aLine-asym",
          "Color": "blonde"
        }
      },
      {
        "value": "hair_aLine-asym-blue",
        "displayName": "ALine Asym Blue",
        "description": {
          "Type": "aLine-asym",
          "Color": "blue"
        }
      },
      {
        "value": "hair_aLine-asym-brown",
        "displayName": "ALine Asym Brown",
        "description": {
          "Type": "aLine-asym",
          "Color": "brown"
        }
      },
      {
        "value": "hair_aLine-asym-dark brown",
        "displayName": "ALine Asym Dark brown",
        "description": {
          "Type": "aLine-asym",
          "Color": "dark brown"
        }
      },
      {
        "value": "hair_aLine-asym-gray",
        "displayName": "ALine Asym Gray",
        "description": {
          "Type": "aLine-asym",
          "Color": "gray"
        }
      },
      {
        "value": "hair_aLine-asym-light brown",
        "displayName": "ALine Asym Light brown",
        "description": {
          "Type": "aLine-asym",
          "Color": "light brown"
        }
      },
      {
        "value": "hair_aLine-asym-pink",
        "displayName": "ALine Asym Pink",
        "description": {
          "Type": "aLine-asym",
          "Color": "pink"
        }
      },
      {
        "value": "hair_aLine-asym-red",
        "displayName": "ALine Asym Red",
        "description": {
          "Type": "aLine-asym",
          "Color": "red"
        }
      },
      {
        "value": "hair_aLine-asym-white",
        "displayName": "ALine Asym White",
        "description": {
          "Type": "aLine-asym",
          "Color": "white"
        }
      },
      {
        "value": "hair_afro-1-black",
        "displayName": "Afro 1 Black",
        "description": {
          "Type": "afro-1",
          "Color": "black"
        }
      },
      {
        "value": "hair_afro-1-blonde",
        "displayName": "Afro 1 Blonde",
        "description": {
          "Type": "afro-1",
          "Color": "blonde"
        }
      },
      {
        "value": "hair_afro-1-blue",
        "displayName": "Afro 1 Blue",
        "description": {
          "Type": "afro-1",
          "Color": "blue"
        }
      },
      {
        "value": "hair_afro-1-brown",
        "displayName": "Afro 1 Brown",
        "description": {
          "Type": "afro-1",
          "Color": "brown"
        }
      },
      {
        "value": "hair_afro-1-dark brown",
        "displayName": "Afro 1 Dark brown",
        "description": {
          "Type": "afro-1",
          "Color": "dark brown"
        }
      },
      {
        "value": "hair_afro-1-gray",
        "displayName": "Afro 1 Gray",
        "description": {
          "Type": "afro-1",
          "Color": "gray"
        }
      },
      {
        "value": "hair_afro-1-light brown",
        "displayName": "Afro 1 Light brown",
        "description": {
          "Type": "afro-1",
          "Color": "light brown"
        }
      },
      {
        "value": "hair_afro-1-pink",
        "displayName": "Afro 1 Pink",
        "description": {
          "Type": "afro-1",
          "Color": "pink"
        }
      },
      {
        "value": "hair_afro-1-red",
        "displayName": "Afro 1 Red",
        "description": {
          "Type": "afro-1",
          "Color": "red"
        }
      },
      {
        "value": "hair_afro-1-white",
        "displayName": "Afro 1 White",
        "description": {
          "Type": "afro-1",
          "Color": "white"
        }
      },
      {
        "value": "hair_afro-2-black",
        "displayName": "Afro 2 Black",
        "description": {
          "Type": "afro-2",
          "Color": "black"
        }
      },
      {
        "value": "hair_afro-2-blonde",
        "displayName": "Afro 2 Blonde",
        "description": {
          "Type": "afro-2",
          "Color": "blonde"
        }
      },
      {
        "value": "hair_afro-2-blue",
        "displayName": "Afro 2 Blue",
        "description": {
          "Type": "afro-2",
          "Color": "blue"
        }
      },
      {
        "value": "hair_afro-2-brown",
        "displayName": "Afro 2 Brown",
        "description": {
          "Type": "afro-2",
          "Color": "brown"
        }
      },
      {
        "value": "hair_afro-2-dark brown",
        "displayName": "Afro 2 Dark brown",
        "description": {
          "Type": "afro-2",
          "Color": "dark brown"
        }
      },
      {
        "value": "hair_afro-2-gray",
        "displayName": "Afro 2 Gray",
        "description": {
          "Type": "afro-2",
          "Color": "gray"
        }
      },
      {
        "value": "hair_afro-2-light brown",
        "displayName": "Afro 2 Light brown",
        "description": {
          "Type": "afro-2",
          "Color": "light brown"
        }
      },
      {
        "value": "hair_afro-2-pink",
        "displayName": "Afro 2 Pink",
        "description": {
          "Type": "afro-2",
          "Color": "pink"
        }
      },
      {
        "value": "hair_afro-2-red",
        "displayName": "Afro 2 Red",
        "description": {
          "Type": "afro-2",
          "Color": "red"
        }
      },
      {
        "value": "hair_afro-2-white",
        "displayName": "Afro 2 White",
        "description": {
          "Type": "afro-2",
          "Color": "white"
        }
      },
      {
        "value": "hair_bob-1-black",
        "displayName": "Bob 1 Black",
        "description": {
          "Type": "bob-1",
          "Color": "black"
        }
      },
      {
        "value": "hair_bob-1-blonde",
        "displayName": "Bob 1 Blonde",
        "description": {
          "Type": "bob-1",
          "Color": "blonde"
        }
      },
      {
        "value": "hair_bob-1-blue",
        "displayName": "Bob 1 Blue",
        "description": {
          "Type": "bob-1",
          "Color": "blue"
        }
      },
      {
        "value": "hair_bob-1-brown",
        "displayName": "Bob 1 Brown",
        "description": {
          "Type": "bob-1",
          "Color": "brown"
        }
      },
      {
        "value": "hair_bob-1-dark brown",
        "displayName": "Bob 1 Dark brown",
        "description": {
          "Type": "bob-1",
          "Color": "dark brown"
        }
      },
      {
        "value": "hair_bob-1-gray",
        "displayName": "Bob 1 Gray",
        "description": {
          "Type": "bob-1",
          "Color": "gray"
        }
      },
      {
        "value": "hair_bob-1-light brown",
        "displayName": "Bob 1 Light brown",
        "description": {
          "Type": "bob-1",
          "Color": "light brown"
        }
      },
      {
        "value": "hair_bob-1-pink",
        "displayName": "Bob 1 Pink",
        "description": {
          "Type": "bob-1",
          "Color": "pink"
        }
      },
      {
        "value": "hair_bob-1-red",
        "displayName": "Bob 1 Red",
        "description": {
          "Type": "bob-1",
          "Color": "red"
        }
      },
      {
        "value": "hair_bob-1-white",
        "displayName": "Bob 1 White",
        "description": {
          "Type": "bob-1",
          "Color": "white"
        }
      },
      {
        "value": "hair_braided-bun-black",
        "displayName": "Braided Bun Black",
        "description": {
          "Type": "braided-bun",
          "Color": "black"
        }
      },
      {
        "value": "hair_braided-bun-blonde",
        "displayName": "Braided Bun Blonde",
        "description": {
          "Type": "braided-bun",
          "Color": "blonde"
        }
      },
      {
        "value": "hair_braided-bun-blue",
        "displayName": "Braided Bun Blue",
        "description": {
          "Type": "braided-bun",
          "Color": "blue"
        }
      },
      {
        "value": "hair_braided-bun-brown",
        "displayName": "Braided Bun Brown",
        "description": {
          "Type": "braided-bun",
          "Color": "brown"
        }
      },
      {
        "value": "hair_braided-bun-dark brown",
        "displayName": "Braided Bun Dark brown",
        "description": {
          "Type": "braided-bun",
          "Color": "dark brown"
        }
      },
      {
        "value": "hair_braided-bun-gray",
        "displayName": "Braided Bun Gray",
        "description": {
          "Type": "braided-bun",
          "Color": "gray"
        }
      },
      {
        "value": "hair_braided-bun-light brown",
        "displayName": "Braided Bun Light brown",
        "description": {
          "Type": "braided-bun",
          "Color": "light brown"
        }
      },
      {
        "value": "hair_braided-bun-pink",
        "displayName": "Braided Bun Pink",
        "description": {
          "Type": "braided-bun",
          "Color": "pink"
        }
      },
      {
        "value": "hair_braided-bun-red",
        "displayName": "Braided Bun Red",
        "description": {
          "Type": "braided-bun",
          "Color": "red"
        }
      },
      {
        "value": "hair_braided-bun-white",
        "displayName": "Braided Bun White",
        "description": {
          "Type": "braided-bun",
          "Color": "white"
        }
      },
      {
        "value": "hair_eraser-top-1-black",
        "displayName": "Eraser Top 1 Black",
        "description": {
          "Type": "eraser-top-1",
          "Color": "black"
        }
      },
      {
        "value": "hair_eraser-top-1-blonde",
        "displayName": "Eraser Top 1 Blonde",
        "description": {
          "Type": "eraser-top-1",
          "Color": "blonde"
        }
      },
      {
        "value": "hair_eraser-top-1-blue",
        "displayName": "Eraser Top 1 Blue",
        "description": {
          "Type": "eraser-top-1",
          "Color": "blue"
        }
      },
      {
        "value": "hair_eraser-top-1-brown",
        "displayName": "Eraser Top 1 Brown",
        "description": {
          "Type": "eraser-top-1",
          "Color": "brown"
        }
      },
      {
        "value": "hair_eraser-top-1-dark brown",
        "displayName": "Eraser Top 1 Dark brown",
        "description": {
          "Type": "eraser-top-1",
          "Color": "dark brown"
        }
      },
      {
        "value": "hair_eraser-top-1-gray",
        "displayName": "Eraser Top 1 Gray",
        "description": {
          "Type": "eraser-top-1",
          "Color": "gray"
        }
      },
      {
        "value": "hair_eraser-top-1-light brown",
        "displayName": "Eraser Top 1 Light brown",
        "description": {
          "Type": "eraser-top-1",
          "Color": "light brown"
        }
      },
      {
        "value": "hair_eraser-top-1-pink",
        "displayName": "Eraser Top 1 Pink",
        "description": {
          "Type": "eraser-top-1",
          "Color": "pink"
        }
      },
      {
        "value": "hair_eraser-top-1-red",
        "displayName": "Eraser Top 1 Red",
        "description": {
          "Type": "eraser-top-1",
          "Color": "red"
        }
      },
      {
        "value": "hair_eraser-top-1-white",
        "displayName": "Eraser Top 1 White",
        "description": {
          "Type": "eraser-top-1",
          "Color": "white"
        }
      },
      {
        "value": "hair_fauxhawk-1-black",
        "displayName": "Fauxhawk 1 Black",
        "description": {
          "Type": "fauxhawk-1",
          "Color": "black"
        }
      },
      {
        "value": "hair_fauxhawk-1-blonde",
        "displayName": "Fauxhawk 1 Blonde",
        "description": {
          "Type": "fauxhawk-1",
          "Color": "blonde"
        }
      },
      {
        "value": "hair_fauxhawk-1-blue",
        "displayName": "Fauxhawk 1 Blue",
        "description": {
          "Type": "fauxhawk-1",
          "Color": "blue"
        }
      },
      {
        "value": "hair_fauxhawk-1-brown",
        "displayName": "Fauxhawk 1 Brown",
        "description": {
          "Type": "fauxhawk-1",
          "Color": "brown"
        }
      },
      {
        "value": "hair_fauxhawk-1-dark brown",
        "displayName": "Fauxhawk 1 Dark brown",
        "description": {
          "Type": "fauxhawk-1",
          "Color": "dark brown"
        }
      },
      {
        "value": "hair_fauxhawk-1-gray",
        "displayName": "Fauxhawk 1 Gray",
        "description": {
          "Type": "fauxhawk-1",
          "Color": "gray"
        }
      },
      {
        "value": "hair_fauxhawk-1-light brown",
        "displayName": "Fauxhawk 1 Light brown",
        "description": {
          "Type": "fauxhawk-1",
          "Color": "light brown"
        }
      },
      {
        "value": "hair_fauxhawk-1-pink",
        "displayName": "Fauxhawk 1 Pink",
        "description": {
          "Type": "fauxhawk-1",
          "Color": "pink"
        }
      },
      {
        "value": "hair_fauxhawk-1-red",
        "displayName": "Fauxhawk 1 Red",
        "description": {
          "Type": "fauxhawk-1",
          "Color": "red"
        }
      },
      {
        "value": "hair_fauxhawk-1-white",
        "displayName": "Fauxhawk 1 White",
        "description": {
          "Type": "fauxhawk-1",
          "Color": "white"
        }
      },
      {
        "value": "hair_flat-top-1-black",
        "displayName": "Flat Top 1 Black",
        "description": {
          "Type": "flat-top-1",
          "Color": "black"
        }
      },
      {
        "value": "hair_flat-top-1-blonde",
        "displayName": "Flat Top 1 Blonde",
        "description": {
          "Type": "flat-top-1",
          "Color": "blonde"
        }
      },
      {
        "value": "hair_flat-top-1-blue",
        "displayName": "Flat Top 1 Blue",
        "description": {
          "Type": "flat-top-1",
          "Color": "blue"
        }
      },
      {
        "value": "hair_flat-top-1-brown",
        "displayName": "Flat Top 1 Brown",
        "description": {
          "Type": "flat-top-1",
          "Color": "brown"
        }
      },
      {
        "value": "hair_flat-top-1-dark brown",
        "displayName": "Flat Top 1 Dark brown",
        "description": {
          "Type": "flat-top-1",
          "Color": "dark brown"
        }
      },
      {
        "value": "hair_flat-top-1-gray",
        "displayName": "Flat Top 1 Gray",
        "description": {
          "Type": "flat-top-1",
          "Color": "gray"
        }
      },
      {
        "value": "hair_flat-top-1-light brown",
        "displayName": "Flat Top 1 Light brown",
        "description": {
          "Type": "flat-top-1",
          "Color": "light brown"
        }
      },
      {
        "value": "hair_flat-top-1-pink",
        "displayName": "Flat Top 1 Pink",
        "description": {
          "Type": "flat-top-1",
          "Color": "pink"
        }
      },
      {
        "value": "hair_flat-top-1-red",
        "displayName": "Flat Top 1 Red",
        "description": {
          "Type": "flat-top-1",
          "Color": "red"
        }
      },
      {
        "value": "hair_flat-top-1-white",
        "displayName": "Flat Top 1 White",
        "description": {
          "Type": "flat-top-1",
          "Color": "white"
        }
      },
      {
        "value": "hair_french-braid-buns-black",
        "displayName": "French Braid Buns Black",
        "description": {
          "Type": "french-braid-buns",
          "Color": "black"
        }
      },
      {
        "value": "hair_french-braid-buns-blonde",
        "displayName": "French Braid Buns Blonde",
        "description": {
          "Type": "french-braid-buns",
          "Color": "blonde"
        }
      },
      {
        "value": "hair_french-braid-buns-blue",
        "displayName": "French Braid Buns Blue",
        "description": {
          "Type": "french-braid-buns",
          "Color": "blue"
        }
      },
      {
        "value": "hair_french-braid-buns-brown",
        "displayName": "French Braid Buns Brown",
        "description": {
          "Type": "french-braid-buns",
          "Color": "brown"
        }
      },
      {
        "value": "hair_french-braid-buns-dark brown",
        "displayName": "French Braid Buns Dark brown",
        "description": {
          "Type": "french-braid-buns",
          "Color": "dark brown"
        }
      },
      {
        "value": "hair_french-braid-buns-gray",
        "displayName": "French Braid Buns Gray",
        "description": {
          "Type": "french-braid-buns",
          "Color": "gray"
        }
      },
      {
        "value": "hair_french-braid-buns-light brown",
        "displayName": "French Braid Buns Light brown",
        "description": {
          "Type": "french-braid-buns",
          "Color": "light brown"
        }
      },
      {
        "value": "hair_french-braid-buns-pink",
        "displayName": "French Braid Buns Pink",
        "description": {
          "Type": "french-braid-buns",
          "Color": "pink"
        }
      },
      {
        "value": "hair_french-braid-buns-red",
        "displayName": "French Braid Buns Red",
        "description": {
          "Type": "french-braid-buns",
          "Color": "red"
        }
      },
      {
        "value": "hair_french-braid-buns-white",
        "displayName": "French Braid Buns White",
        "description": {
          "Type": "french-braid-buns",
          "Color": "white"
        }
      },
      {
        "value": "hair_french-braids-double-black",
        "displayName": "French Braids Double Black",
        "description": {
          "Type": "french-braids-double",
          "Color": "black"
        }
      },
      {
        "value": "hair_french-braids-double-blonde",
        "displayName": "French Braids Double Blonde",
        "description": {
          "Type": "french-braids-double",
          "Color": "blonde"
        }
      },
      {
        "value": "hair_french-braids-double-blue",
        "displayName": "French Braids Double Blue",
        "description": {
          "Type": "french-braids-double",
          "Color": "blue"
        }
      },
      {
        "value": "hair_french-braids-double-brown",
        "displayName": "French Braids Double Brown",
        "description": {
          "Type": "french-braids-double",
          "Color": "brown"
        }
      },
      {
        "value": "hair_french-braids-double-dark brown",
        "displayName": "French Braids Double Dark brown",
        "description": {
          "Type": "french-braids-double",
          "Color": "dark brown"
        }
      },
      {
        "value": "hair_french-braids-double-gray",
        "displayName": "French Braids Double Gray",
        "description": {
          "Type": "french-braids-double",
          "Color": "gray"
        }
      },
      {
        "value": "hair_french-braids-double-light brown",
        "displayName": "French Braids Double Light brown",
        "description": {
          "Type": "french-braids-double",
          "Color": "light brown"
        }
      },
      {
        "value": "hair_french-braids-double-pink",
        "displayName": "French Braids Double Pink",
        "description": {
          "Type": "french-braids-double",
          "Color": "pink"
        }
      },
      {
        "value": "hair_french-braids-double-red",
        "displayName": "French Braids Double Red",
        "description": {
          "Type": "french-braids-double",
          "Color": "red"
        }
      },
      {
        "value": "hair_french-braids-double-white",
        "displayName": "French Braids Double White",
        "description": {
          "Type": "french-braids-double",
          "Color": "white"
        }
      },
      {
        "value": "hair_mohawk-1-black",
        "displayName": "Mohawk 1 Black",
        "description": {
          "Type": "mohawk-1",
          "Color": "black"
        }
      },
      {
        "value": "hair_mohawk-1-blonde",
        "displayName": "Mohawk 1 Blonde",
        "description": {
          "Type": "mohawk-1",
          "Color": "blonde"
        }
      },
      {
        "value": "hair_mohawk-1-blue",
        "displayName": "Mohawk 1 Blue",
        "description": {
          "Type": "mohawk-1",
          "Color": "blue"
        }
      },
      {
        "value": "hair_mohawk-1-brown",
        "displayName": "Mohawk 1 Brown",
        "description": {
          "Type": "mohawk-1",
          "Color": "brown"
        }
      },
      {
        "value": "hair_mohawk-1-dark brown",
        "displayName": "Mohawk 1 Dark brown",
        "description": {
          "Type": "mohawk-1",
          "Color": "dark brown"
        }
      },
      {
        "value": "hair_mohawk-1-gray",
        "displayName": "Mohawk 1 Gray",
        "description": {
          "Type": "mohawk-1",
          "Color": "gray"
        }
      },
      {
        "value": "hair_mohawk-1-light brown",
        "displayName": "Mohawk 1 Light brown",
        "description": {
          "Type": "mohawk-1",
          "Color": "light brown"
        }
      },
      {
        "value": "hair_mohawk-1-pink",
        "displayName": "Mohawk 1 Pink",
        "description": {
          "Type": "mohawk-1",
          "Color": "pink"
        }
      },
      {
        "value": "hair_mohawk-1-red",
        "displayName": "Mohawk 1 Red",
        "description": {
          "Type": "mohawk-1",
          "Color": "red"
        }
      },
      {
        "value": "hair_mohawk-1-white",
        "displayName": "Mohawk 1 White",
        "description": {
          "Type": "mohawk-1",
          "Color": "white"
        }
      },
      {
        "value": "hair_mullet-1-black",
        "displayName": "Mullet 1 Black",
        "description": {
          "Type": "mullet-1",
          "Color": "black"
        }
      },
      {
        "value": "hair_mullet-1-blonde",
        "displayName": "Mullet 1 Blonde",
        "description": {
          "Type": "mullet-1",
          "Color": "blonde"
        }
      },
      {
        "value": "hair_mullet-1-blue",
        "displayName": "Mullet 1 Blue",
        "description": {
          "Type": "mullet-1",
          "Color": "blue"
        }
      },
      {
        "value": "hair_mullet-1-brown",
        "displayName": "Mullet 1 Brown",
        "description": {
          "Type": "mullet-1",
          "Color": "brown"
        }
      },
      {
        "value": "hair_mullet-1-dark brown",
        "displayName": "Mullet 1 Dark brown",
        "description": {
          "Type": "mullet-1",
          "Color": "dark brown"
        }
      },
      {
        "value": "hair_mullet-1-gray",
        "displayName": "Mullet 1 Gray",
        "description": {
          "Type": "mullet-1",
          "Color": "gray"
        }
      },
      {
        "value": "hair_mullet-1-light brown",
        "displayName": "Mullet 1 Light brown",
        "description": {
          "Type": "mullet-1",
          "Color": "light brown"
        }
      },
      {
        "value": "hair_mullet-1-pink",
        "displayName": "Mullet 1 Pink",
        "description": {
          "Type": "mullet-1",
          "Color": "pink"
        }
      },
      {
        "value": "hair_mullet-1-red",
        "displayName": "Mullet 1 Red",
        "description": {
          "Type": "mullet-1",
          "Color": "red"
        }
      },
      {
        "value": "hair_mullet-1-white",
        "displayName": "Mullet 1 White",
        "description": {
          "Type": "mullet-1",
          "Color": "white"
        }
      },
      {
        "value": "hair_parted-1-black",
        "displayName": "Parted 1 Black",
        "description": {
          "Type": "parted-1",
          "Color": "black"
        }
      },
      {
        "value": "hair_parted-1-blonde",
        "displayName": "Parted 1 Blonde",
        "description": {
          "Type": "parted-1",
          "Color": "blonde"
        }
      },
      {
        "value": "hair_parted-1-blue",
        "displayName": "Parted 1 Blue",
        "description": {
          "Type": "parted-1",
          "Color": "blue"
        }
      },
      {
        "value": "hair_parted-1-brown",
        "displayName": "Parted 1 Brown",
        "description": {
          "Type": "parted-1",
          "Color": "brown"
        }
      },
      {
        "value": "hair_parted-1-dark brown",
        "displayName": "Parted 1 Dark brown",
        "description": {
          "Type": "parted-1",
          "Color": "dark brown"
        }
      },
      {
        "value": "hair_parted-1-gray",
        "displayName": "Parted 1 Gray",
        "description": {
          "Type": "parted-1",
          "Color": "gray"
        }
      },
      {
        "value": "hair_parted-1-light brown",
        "displayName": "Parted 1 Light brown",
        "description": {
          "Type": "parted-1",
          "Color": "light brown"
        }
      },
      {
        "value": "hair_parted-1-pink",
        "displayName": "Parted 1 Pink",
        "description": {
          "Type": "parted-1",
          "Color": "pink"
        }
      },
      {
        "value": "hair_parted-1-red",
        "displayName": "Parted 1 Red",
        "description": {
          "Type": "parted-1",
          "Color": "red"
        }
      },
      {
        "value": "hair_parted-1-white",
        "displayName": "Parted 1 White",
        "description": {
          "Type": "parted-1",
          "Color": "white"
        }
      },
      {
        "value": "hair_parted-long-1-black",
        "displayName": "Parted Long 1 Black",
        "description": {
          "Type": "parted-long-1",
          "Color": "black"
        }
      },
      {
        "value": "hair_parted-long-1-blonde",
        "displayName": "Parted Long 1 Blonde",
        "description": {
          "Type": "parted-long-1",
          "Color": "blonde"
        }
      },
      {
        "value": "hair_parted-long-1-blue",
        "displayName": "Parted Long 1 Blue",
        "description": {
          "Type": "parted-long-1",
          "Color": "blue"
        }
      },
      {
        "value": "hair_parted-long-1-brown",
        "displayName": "Parted Long 1 Brown",
        "description": {
          "Type": "parted-long-1",
          "Color": "brown"
        }
      },
      {
        "value": "hair_parted-long-1-dark brown",
        "displayName": "Parted Long 1 Dark brown",
        "description": {
          "Type": "parted-long-1",
          "Color": "dark brown"
        }
      },
      {
        "value": "hair_parted-long-1-gray",
        "displayName": "Parted Long 1 Gray",
        "description": {
          "Type": "parted-long-1",
          "Color": "gray"
        }
      },
      {
        "value": "hair_parted-long-1-light brown",
        "displayName": "Parted Long 1 Light brown",
        "description": {
          "Type": "parted-long-1",
          "Color": "light brown"
        }
      },
      {
        "value": "hair_parted-long-1-pink",
        "displayName": "Parted Long 1 Pink",
        "description": {
          "Type": "parted-long-1",
          "Color": "pink"
        }
      },
      {
        "value": "hair_parted-long-1-red",
        "displayName": "Parted Long 1 Red",
        "description": {
          "Type": "parted-long-1",
          "Color": "red"
        }
      },
      {
        "value": "hair_parted-long-1-white",
        "displayName": "Parted Long 1 White",
        "description": {
          "Type": "parted-long-1",
          "Color": "white"
        }
      },
      {
        "value": "hair_pigtails-1-black",
        "displayName": "Pigtails 1 Black",
        "description": {
          "Type": "pigtails-1",
          "Color": "black"
        }
      },
      {
        "value": "hair_pigtails-1-blonde",
        "displayName": "Pigtails 1 Blonde",
        "description": {
          "Type": "pigtails-1",
          "Color": "blonde"
        }
      },
      {
        "value": "hair_pigtails-1-blue",
        "displayName": "Pigtails 1 Blue",
        "description": {
          "Type": "pigtails-1",
          "Color": "blue"
        }
      },
      {
        "value": "hair_pigtails-1-brown",
        "displayName": "Pigtails 1 Brown",
        "description": {
          "Type": "pigtails-1",
          "Color": "brown"
        }
      },
      {
        "value": "hair_pigtails-1-dark brown",
        "displayName": "Pigtails 1 Dark brown",
        "description": {
          "Type": "pigtails-1",
          "Color": "dark brown"
        }
      },
      {
        "value": "hair_pigtails-1-gray",
        "displayName": "Pigtails 1 Gray",
        "description": {
          "Type": "pigtails-1",
          "Color": "gray"
        }
      },
      {
        "value": "hair_pigtails-1-light brown",
        "displayName": "Pigtails 1 Light brown",
        "description": {
          "Type": "pigtails-1",
          "Color": "light brown"
        }
      },
      {
        "value": "hair_pigtails-1-pink",
        "displayName": "Pigtails 1 Pink",
        "description": {
          "Type": "pigtails-1",
          "Color": "pink"
        }
      },
      {
        "value": "hair_pigtails-1-red",
        "displayName": "Pigtails 1 Red",
        "description": {
          "Type": "pigtails-1",
          "Color": "red"
        }
      },
      {
        "value": "hair_pigtails-1-white",
        "displayName": "Pigtails 1 White",
        "description": {
          "Type": "pigtails-1",
          "Color": "white"
        }
      },
      {
        "value": "hair_pony-tail-1-black",
        "displayName": "Pony Tail 1 Black",
        "description": {
          "Type": "pony-tail-1",
          "Color": "black"
        }
      },
      {
        "value": "hair_pony-tail-1-blonde",
        "displayName": "Pony Tail 1 Blonde",
        "description": {
          "Type": "pony-tail-1",
          "Color": "blonde"
        }
      },
      {
        "value": "hair_pony-tail-1-blue",
        "displayName": "Pony Tail 1 Blue",
        "description": {
          "Type": "pony-tail-1",
          "Color": "blue"
        }
      },
      {
        "value": "hair_pony-tail-1-brown",
        "displayName": "Pony Tail 1 Brown",
        "description": {
          "Type": "pony-tail-1",
          "Color": "brown"
        }
      },
      {
        "value": "hair_pony-tail-1-dark brown",
        "displayName": "Pony Tail 1 Dark brown",
        "description": {
          "Type": "pony-tail-1",
          "Color": "dark brown"
        }
      },
      {
        "value": "hair_pony-tail-1-gray",
        "displayName": "Pony Tail 1 Gray",
        "description": {
          "Type": "pony-tail-1",
          "Color": "gray"
        }
      },
      {
        "value": "hair_pony-tail-1-light brown",
        "displayName": "Pony Tail 1 Light brown",
        "description": {
          "Type": "pony-tail-1",
          "Color": "light brown"
        }
      },
      {
        "value": "hair_pony-tail-1-pink",
        "displayName": "Pony Tail 1 Pink",
        "description": {
          "Type": "pony-tail-1",
          "Color": "pink"
        }
      },
      {
        "value": "hair_pony-tail-1-red",
        "displayName": "Pony Tail 1 Red",
        "description": {
          "Type": "pony-tail-1",
          "Color": "red"
        }
      },
      {
        "value": "hair_pony-tail-1-white",
        "displayName": "Pony Tail 1 White",
        "description": {
          "Type": "pony-tail-1",
          "Color": "white"
        }
      },
      {
        "value": "hair_pony-tail-2-black",
        "displayName": "Pony Tail 2 Black",
        "description": {
          "Type": "pony-tail-2",
          "Color": "black"
        }
      },
      {
        "value": "hair_pony-tail-2-blonde",
        "displayName": "Pony Tail 2 Blonde",
        "description": {
          "Type": "pony-tail-2",
          "Color": "blonde"
        }
      },
      {
        "value": "hair_pony-tail-2-blue",
        "displayName": "Pony Tail 2 Blue",
        "description": {
          "Type": "pony-tail-2",
          "Color": "blue"
        }
      },
      {
        "value": "hair_pony-tail-2-brown",
        "displayName": "Pony Tail 2 Brown",
        "description": {
          "Type": "pony-tail-2",
          "Color": "brown"
        }
      },
      {
        "value": "hair_pony-tail-2-dark brown",
        "displayName": "Pony Tail 2 Dark brown",
        "description": {
          "Type": "pony-tail-2",
          "Color": "dark brown"
        }
      },
      {
        "value": "hair_pony-tail-2-gray",
        "displayName": "Pony Tail 2 Gray",
        "description": {
          "Type": "pony-tail-2",
          "Color": "gray"
        }
      },
      {
        "value": "hair_pony-tail-2-light brown",
        "displayName": "Pony Tail 2 Light brown",
        "description": {
          "Type": "pony-tail-2",
          "Color": "light brown"
        }
      },
      {
        "value": "hair_pony-tail-2-pink",
        "displayName": "Pony Tail 2 Pink",
        "description": {
          "Type": "pony-tail-2",
          "Color": "pink"
        }
      },
      {
        "value": "hair_pony-tail-2-red",
        "displayName": "Pony Tail 2 Red",
        "description": {
          "Type": "pony-tail-2",
          "Color": "red"
        }
      },
      {
        "value": "hair_pony-tail-2-white",
        "displayName": "Pony Tail 2 White",
        "description": {
          "Type": "pony-tail-2",
          "Color": "white"
        }
      },
      {
        "value": "hair_pony-tail-3-black",
        "displayName": "Pony Tail 3 Black",
        "description": {
          "Type": "pony-tail-3",
          "Color": "black"
        }
      },
      {
        "value": "hair_pony-tail-3-blonde",
        "displayName": "Pony Tail 3 Blonde",
        "description": {
          "Type": "pony-tail-3",
          "Color": "blonde"
        }
      },
      {
        "value": "hair_pony-tail-3-blue",
        "displayName": "Pony Tail 3 Blue",
        "description": {
          "Type": "pony-tail-3",
          "Color": "blue"
        }
      },
      {
        "value": "hair_pony-tail-3-brown",
        "displayName": "Pony Tail 3 Brown",
        "description": {
          "Type": "pony-tail-3",
          "Color": "brown"
        }
      },
      {
        "value": "hair_pony-tail-3-dark brown",
        "displayName": "Pony Tail 3 Dark brown",
        "description": {
          "Type": "pony-tail-3",
          "Color": "dark brown"
        }
      },
      {
        "value": "hair_pony-tail-3-gray",
        "displayName": "Pony Tail 3 Gray",
        "description": {
          "Type": "pony-tail-3",
          "Color": "gray"
        }
      },
      {
        "value": "hair_pony-tail-3-light brown",
        "displayName": "Pony Tail 3 Light brown",
        "description": {
          "Type": "pony-tail-3",
          "Color": "light brown"
        }
      },
      {
        "value": "hair_pony-tail-3-pink",
        "displayName": "Pony Tail 3 Pink",
        "description": {
          "Type": "pony-tail-3",
          "Color": "pink"
        }
      },
      {
        "value": "hair_pony-tail-3-red",
        "displayName": "Pony Tail 3 Red",
        "description": {
          "Type": "pony-tail-3",
          "Color": "red"
        }
      },
      {
        "value": "hair_pony-tail-3-white",
        "displayName": "Pony Tail 3 White",
        "description": {
          "Type": "pony-tail-3",
          "Color": "white"
        }
      },
      {
        "value": "hair_short-wave-1-black",
        "displayName": "Short Wave 1 Black",
        "description": {
          "Type": "short-wave-1",
          "Color": "black"
        }
      },
      {
        "value": "hair_short-wave-1-blonde",
        "displayName": "Short Wave 1 Blonde",
        "description": {
          "Type": "short-wave-1",
          "Color": "blonde"
        }
      },
      {
        "value": "hair_short-wave-1-blue",
        "displayName": "Short Wave 1 Blue",
        "description": {
          "Type": "short-wave-1",
          "Color": "blue"
        }
      },
      {
        "value": "hair_short-wave-1-brown",
        "displayName": "Short Wave 1 Brown",
        "description": {
          "Type": "short-wave-1",
          "Color": "brown"
        }
      },
      {
        "value": "hair_short-wave-1-dark brown",
        "displayName": "Short Wave 1 Dark brown",
        "description": {
          "Type": "short-wave-1",
          "Color": "dark brown"
        }
      },
      {
        "value": "hair_short-wave-1-gray",
        "displayName": "Short Wave 1 Gray",
        "description": {
          "Type": "short-wave-1",
          "Color": "gray"
        }
      },
      {
        "value": "hair_short-wave-1-light brown",
        "displayName": "Short Wave 1 Light brown",
        "description": {
          "Type": "short-wave-1",
          "Color": "light brown"
        }
      },
      {
        "value": "hair_short-wave-1-pink",
        "displayName": "Short Wave 1 Pink",
        "description": {
          "Type": "short-wave-1",
          "Color": "pink"
        }
      },
      {
        "value": "hair_short-wave-1-red",
        "displayName": "Short Wave 1 Red",
        "description": {
          "Type": "short-wave-1",
          "Color": "red"
        }
      },
      {
        "value": "hair_short-wave-1-white",
        "displayName": "Short Wave 1 White",
        "description": {
          "Type": "short-wave-1",
          "Color": "white"
        }
      },
      {
        "value": "hair_spikey-1-black",
        "displayName": "Spikey 1 Black",
        "description": {
          "Type": "spikey-1",
          "Color": "black"
        }
      },
      {
        "value": "hair_spikey-1-blonde",
        "displayName": "Spikey 1 Blonde",
        "description": {
          "Type": "spikey-1",
          "Color": "blonde"
        }
      },
      {
        "value": "hair_spikey-1-blue",
        "displayName": "Spikey 1 Blue",
        "description": {
          "Type": "spikey-1",
          "Color": "blue"
        }
      },
      {
        "value": "hair_spikey-1-brown",
        "displayName": "Spikey 1 Brown",
        "description": {
          "Type": "spikey-1",
          "Color": "brown"
        }
      },
      {
        "value": "hair_spikey-1-dark brown",
        "displayName": "Spikey 1 Dark brown",
        "description": {
          "Type": "spikey-1",
          "Color": "dark brown"
        }
      },
      {
        "value": "hair_spikey-1-gray",
        "displayName": "Spikey 1 Gray",
        "description": {
          "Type": "spikey-1",
          "Color": "gray"
        }
      },
      {
        "value": "hair_spikey-1-light brown",
        "displayName": "Spikey 1 Light brown",
        "description": {
          "Type": "spikey-1",
          "Color": "light brown"
        }
      },
      {
        "value": "hair_spikey-1-pink",
        "displayName": "Spikey 1 Pink",
        "description": {
          "Type": "spikey-1",
          "Color": "pink"
        }
      },
      {
        "value": "hair_spikey-1-red",
        "displayName": "Spikey 1 Red",
        "description": {
          "Type": "spikey-1",
          "Color": "red"
        }
      },
      {
        "value": "hair_spikey-1-white",
        "displayName": "Spikey 1 White",
        "description": {
          "Type": "spikey-1",
          "Color": "white"
        }
      },
      {
        "value": "hair_taper-afro-2-black",
        "displayName": "Taper Afro 2 Black",
        "description": {
          "Type": "taper-afro-2",
          "Color": "black"
        }
      },
      {
        "value": "hair_taper-afro-2-blonde",
        "displayName": "Taper Afro 2 Blonde",
        "description": {
          "Type": "taper-afro-2",
          "Color": "blonde"
        }
      },
      {
        "value": "hair_taper-afro-2-blue",
        "displayName": "Taper Afro 2 Blue",
        "description": {
          "Type": "taper-afro-2",
          "Color": "blue"
        }
      },
      {
        "value": "hair_taper-afro-2-brown",
        "displayName": "Taper Afro 2 Brown",
        "description": {
          "Type": "taper-afro-2",
          "Color": "brown"
        }
      },
      {
        "value": "hair_taper-afro-2-dark brown",
        "displayName": "Taper Afro 2 Dark brown",
        "description": {
          "Type": "taper-afro-2",
          "Color": "dark brown"
        }
      },
      {
        "value": "hair_taper-afro-2-gray",
        "displayName": "Taper Afro 2 Gray",
        "description": {
          "Type": "taper-afro-2",
          "Color": "gray"
        }
      },
      {
        "value": "hair_taper-afro-2-light brown",
        "displayName": "Taper Afro 2 Light brown",
        "description": {
          "Type": "taper-afro-2",
          "Color": "light brown"
        }
      },
      {
        "value": "hair_taper-afro-2-pink",
        "displayName": "Taper Afro 2 Pink",
        "description": {
          "Type": "taper-afro-2",
          "Color": "pink"
        }
      },
      {
        "value": "hair_taper-afro-2-red",
        "displayName": "Taper Afro 2 Red",
        "description": {
          "Type": "taper-afro-2",
          "Color": "red"
        }
      },
      {
        "value": "hair_taper-afro-2-white",
        "displayName": "Taper Afro 2 White",
        "description": {
          "Type": "taper-afro-2",
          "Color": "white"
        }
      }
    ],
    "description": {
      "Type": {
        "options": [
          null,
          "aLine-asym",
          "afro-1",
          "afro-2",
          "bob-1",
          "braided-bun",
          "eraser-top-1",
          "fauxhawk-1",
          "flat-top-1",
          "french-braid-buns",
          "french-braids-double",
          "mohawk-1",
          "mullet-1",
          "parted-1",
          "parted-long-1",
          "pigtails-1",
          "pony-tail-1",
          "pony-tail-2",
          "pony-tail-3",
          "short-wave-1",
          "spikey-1",
          "taper-afro-2"
        ],
        "isPrimaryOption": true
      },
      "Color": {
        "options": [
          "black",
          "blonde",
          "blue",
          "brown",
          "dark brown",
          "gray",
          "light brown",
          "pink",
          "red",
          "white"
        ]
      }
    }
  },
  "Head": {
    "parts": [
      {
        "value": null,
        "displayName": "None",
        "excludeFromRandomize": true
      },
      {
        "value": "head_bald-skin-1",
        "displayName": "Bald Skin 1",
        "description": {
          "Type": "bald",
          "Skin Tone": "skin-1"
        }
      },
      {
        "value": "head_bald-skin-2",
        "displayName": "Bald Skin 2",
        "description": {
          "Type": "bald",
          "Skin Tone": "skin-2"
        }
      },
      {
        "value": "head_bald-skin-3",
        "displayName": "Bald Skin 3",
        "description": {
          "Type": "bald",
          "Skin Tone": "skin-3"
        }
      },
      {
        "value": "head_bald-skin-4",
        "displayName": "Bald Skin 4",
        "description": {
          "Type": "bald",
          "Skin Tone": "skin-4"
        }
      },
      {
        "value": "head_bald-skin-5",
        "displayName": "Bald Skin 5",
        "description": {
          "Type": "bald",
          "Skin Tone": "skin-5"
        }
      },
      {
        "value": "head_bald-skin-6",
        "displayName": "Bald Skin 6",
        "description": {
          "Type": "bald",
          "Skin Tone": "skin-6"
        }
      },
      {
        "value": "head_bald-skin-7",
        "displayName": "Bald Skin 7",
        "description": {
          "Type": "bald",
          "Skin Tone": "skin-7"
        }
      },
      {
        "value": "head_bald-skin-8",
        "displayName": "Bald Skin 8",
        "description": {
          "Type": "bald",
          "Skin Tone": "skin-8"
        }
      },
      {
        "value": "head_bald-skin-a",
        "displayName": "Bald Skin A",
        "description": {
          "Type": "bald",
          "Skin Tone": "skin-a"
        }
      },
      {
        "value": "head_bald-skin-b",
        "displayName": "Bald Skin B",
        "description": {
          "Type": "bald",
          "Skin Tone": "skin-b"
        }
      },
      {
        "value": "head_bald-skin-c",
        "displayName": "Bald Skin C",
        "description": {
          "Type": "bald",
          "Skin Tone": "skin-c"
        }
      },
      {
        "value": "head_bald-skin-d",
        "displayName": "Bald Skin D",
        "description": {
          "Type": "bald",
          "Skin Tone": "skin-d"
        }
      },
      {
        "value": "head_bald-skin-e",
        "displayName": "Bald Skin E",
        "description": {
          "Type": "bald",
          "Skin Tone": "skin-e"
        }
      },
      {
        "value": "head_bald-skin-f",
        "displayName": "Bald Skin F",
        "description": {
          "Type": "bald",
          "Skin Tone": "skin-f"
        }
      },
      {
        "value": "head_bald-skin-g",
        "displayName": "Bald Skin G",
        "description": {
          "Type": "bald",
          "Skin Tone": "skin-g"
        }
      },
      {
        "value": "head_bald-skin-h",
        "displayName": "Bald Skin H",
        "description": {
          "Type": "bald",
          "Skin Tone": "skin-h"
        }
      },
      {
        "value": "head_freckles-skin-1",
        "displayName": "Freckles Skin 1",
        "description": {
          "Type": "freckles",
          "Skin Tone": "skin-1"
        }
      },
      {
        "value": "head_freckles-skin-2",
        "displayName": "Freckles Skin 2",
        "description": {
          "Type": "freckles",
          "Skin Tone": "skin-2"
        }
      },
      {
        "value": "head_freckles-skin-3",
        "displayName": "Freckles Skin 3",
        "description": {
          "Type": "freckles",
          "Skin Tone": "skin-3"
        }
      },
      {
        "value": "head_freckles-skin-4",
        "displayName": "Freckles Skin 4",
        "description": {
          "Type": "freckles",
          "Skin Tone": "skin-4"
        }
      },
      {
        "value": "head_freckles-skin-5",
        "displayName": "Freckles Skin 5",
        "description": {
          "Type": "freckles",
          "Skin Tone": "skin-5"
        }
      },
      {
        "value": "head_freckles-skin-6",
        "displayName": "Freckles Skin 6",
        "description": {
          "Type": "freckles",
          "Skin Tone": "skin-6"
        }
      },
      {
        "value": "head_freckles-skin-7",
        "displayName": "Freckles Skin 7",
        "description": {
          "Type": "freckles",
          "Skin Tone": "skin-7"
        }
      },
      {
        "value": "head_freckles-skin-8",
        "displayName": "Freckles Skin 8",
        "description": {
          "Type": "freckles",
          "Skin Tone": "skin-8"
        }
      },
      {
        "value": "head_freckles-skin-a",
        "displayName": "Freckles Skin A",
        "description": {
          "Type": "freckles",
          "Skin Tone": "skin-a"
        }
      },
      {
        "value": "head_freckles-skin-b",
        "displayName": "Freckles Skin B",
        "description": {
          "Type": "freckles",
          "Skin Tone": "skin-b"
        }
      },
      {
        "value": "head_freckles-skin-c",
        "displayName": "Freckles Skin C",
        "description": {
          "Type": "freckles",
          "Skin Tone": "skin-c"
        }
      },
      {
        "value": "head_freckles-skin-d",
        "displayName": "Freckles Skin D",
        "description": {
          "Type": "freckles",
          "Skin Tone": "skin-d"
        }
      },
      {
        "value": "head_freckles-skin-e",
        "displayName": "Freckles Skin E",
        "description": {
          "Type": "freckles",
          "Skin Tone": "skin-e"
        }
      },
      {
        "value": "head_freckles-skin-f",
        "displayName": "Freckles Skin F",
        "description": {
          "Type": "freckles",
          "Skin Tone": "skin-f"
        }
      },
      {
        "value": "head_freckles-skin-g",
        "displayName": "Freckles Skin G",
        "description": {
          "Type": "freckles",
          "Skin Tone": "skin-g"
        }
      },
      {
        "value": "head_freckles-skin-h",
        "displayName": "Freckles Skin H",
        "description": {
          "Type": "freckles",
          "Skin Tone": "skin-h"
        }
      },
      {
        "value": "head_shaved-skin-1",
        "displayName": "Shaved Skin 1",
        "description": {
          "Type": "shaved",
          "Skin Tone": "skin-1"
        }
      },
      {
        "value": "head_shaved-skin-2",
        "displayName": "Shaved Skin 2",
        "description": {
          "Type": "shaved",
          "Skin Tone": "skin-2"
        }
      },
      {
        "value": "head_shaved-skin-3",
        "displayName": "Shaved Skin 3",
        "description": {
          "Type": "shaved",
          "Skin Tone": "skin-3"
        }
      },
      {
        "value": "head_shaved-skin-4",
        "displayName": "Shaved Skin 4",
        "description": {
          "Type": "shaved",
          "Skin Tone": "skin-4"
        }
      },
      {
        "value": "head_shaved-skin-5",
        "displayName": "Shaved Skin 5",
        "description": {
          "Type": "shaved",
          "Skin Tone": "skin-5"
        }
      },
      {
        "value": "head_shaved-skin-6",
        "displayName": "Shaved Skin 6",
        "description": {
          "Type": "shaved",
          "Skin Tone": "skin-6"
        }
      },
      {
        "value": "head_shaved-skin-7",
        "displayName": "Shaved Skin 7",
        "description": {
          "Type": "shaved",
          "Skin Tone": "skin-7"
        }
      },
      {
        "value": "head_shaved-skin-8",
        "displayName": "Shaved Skin 8",
        "description": {
          "Type": "shaved",
          "Skin Tone": "skin-8"
        }
      },
      {
        "value": "head_shaved-skin-a",
        "displayName": "Shaved Skin A",
        "description": {
          "Type": "shaved",
          "Skin Tone": "skin-a"
        }
      },
      {
        "value": "head_shaved-skin-b",
        "displayName": "Shaved Skin B",
        "description": {
          "Type": "shaved",
          "Skin Tone": "skin-b"
        }
      },
      {
        "value": "head_shaved-skin-c",
        "displayName": "Shaved Skin C",
        "description": {
          "Type": "shaved",
          "Skin Tone": "skin-c"
        }
      },
      {
        "value": "head_shaved-skin-d",
        "displayName": "Shaved Skin D",
        "description": {
          "Type": "shaved",
          "Skin Tone": "skin-d"
        }
      },
      {
        "value": "head_shaved-skin-e",
        "displayName": "Shaved Skin E",
        "description": {
          "Type": "shaved",
          "Skin Tone": "skin-e"
        }
      },
      {
        "value": "head_shaved-skin-f",
        "displayName": "Shaved Skin F",
        "description": {
          "Type": "shaved",
          "Skin Tone": "skin-f"
        }
      },
      {
        "value": "head_shaved-skin-g",
        "displayName": "Shaved Skin G",
        "description": {
          "Type": "shaved",
          "Skin Tone": "skin-g"
        }
      },
      {
        "value": "head_shaved-skin-h",
        "displayName": "Shaved Skin H",
        "description": {
          "Type": "shaved",
          "Skin Tone": "skin-h"
        }
      }
    ],
    "description": {
      "Type": {
        "options": [
          null,
          "bald",
          "freckles",
          "shaved"
        ],
        "isPrimaryOption": true
      },
      "Skin Tone": {
        "options": [
          "skin-1",
          "skin-2",
          "skin-3",
          "skin-4",
          "skin-5",
          "skin-6",
          "skin-7",
          "skin-8",
          "skin-a",
          "skin-b",
          "skin-c",
          "skin-d",
          "skin-e",
          "skin-f",
          "skin-g",
          "skin-h"
        ]
      }
    }
  },
  "Eyes": {
    "parts": [
      {
        "value": null,
        "displayName": "None",
        "excludeFromRandomize": true
      },
      {
        "value": "eyes_style-1-blue",
        "displayName": "Style 1 Blue",
        "description": {
          "Style": "style-1",
          "Color": "blue"
        }
      },
      {
        "value": "eyes_style-1-brown",
        "displayName": "Style 1 Brown",
        "description": {
          "Style": "style-1",
          "Color": "brown"
        }
      },
      {
        "value": "eyes_style-1-gray",
        "displayName": "Style 1 Gray",
        "description": {
          "Style": "style-1",
          "Color": "gray"
        }
      },
      {
        "value": "eyes_style-1-green",
        "displayName": "Style 1 Green",
        "description": {
          "Style": "style-1",
          "Color": "green"
        }
      },
      {
        "value": "eyes_style-1-hazel",
        "displayName": "Style 1 Hazel",
        "description": {
          "Style": "style-1",
          "Color": "hazel"
        }
      },
      {
        "value": "eyes_style-11-blue",
        "displayName": "Style 11 Blue",
        "description": {
          "Style": "style-11",
          "Color": "blue"
        }
      },
      {
        "value": "eyes_style-11-brown",
        "displayName": "Style 11 Brown",
        "description": {
          "Style": "style-11",
          "Color": "brown"
        }
      },
      {
        "value": "eyes_style-11-gray",
        "displayName": "Style 11 Gray",
        "description": {
          "Style": "style-11",
          "Color": "gray"
        }
      },
      {
        "value": "eyes_style-11-green",
        "displayName": "Style 11 Green",
        "description": {
          "Style": "style-11",
          "Color": "green"
        }
      },
      {
        "value": "eyes_style-11-hazel",
        "displayName": "Style 11 Hazel",
        "description": {
          "Style": "style-11",
          "Color": "hazel"
        }
      },
      {
        "value": "eyes_style-12-blue",
        "displayName": "Style 12 Blue",
        "description": {
          "Style": "style-12",
          "Color": "blue"
        }
      },
      {
        "value": "eyes_style-12-brown",
        "displayName": "Style 12 Brown",
        "description": {
          "Style": "style-12",
          "Color": "brown"
        }
      },
      {
        "value": "eyes_style-12-gray",
        "displayName": "Style 12 Gray",
        "description": {
          "Style": "style-12",
          "Color": "gray"
        }
      },
      {
        "value": "eyes_style-12-green",
        "displayName": "Style 12 Green",
        "description": {
          "Style": "style-12",
          "Color": "green"
        }
      },
      {
        "value": "eyes_style-12-hazel",
        "displayName": "Style 12 Hazel",
        "description": {
          "Style": "style-12",
          "Color": "hazel"
        }
      },
      {
        "value": "eyes_style-13-blue",
        "displayName": "Style 13 Blue",
        "description": {
          "Style": "style-13",
          "Color": "blue"
        }
      },
      {
        "value": "eyes_style-13-brown",
        "displayName": "Style 13 Brown",
        "description": {
          "Style": "style-13",
          "Color": "brown"
        }
      },
      {
        "value": "eyes_style-13-gray",
        "displayName": "Style 13 Gray",
        "description": {
          "Style": "style-13",
          "Color": "gray"
        }
      },
      {
        "value": "eyes_style-13-green",
        "displayName": "Style 13 Green",
        "description": {
          "Style": "style-13",
          "Color": "green"
        }
      },
      {
        "value": "eyes_style-13-hazel",
        "displayName": "Style 13 Hazel",
        "description": {
          "Style": "style-13",
          "Color": "hazel"
        }
      },
      {
        "value": "eyes_style-14-blue",
        "displayName": "Style 14 Blue",
        "description": {
          "Style": "style-14",
          "Color": "blue"
        }
      },
      {
        "value": "eyes_style-14-brown",
        "displayName": "Style 14 Brown",
        "description": {
          "Style": "style-14",
          "Color": "brown"
        }
      },
      {
        "value": "eyes_style-14-gray",
        "displayName": "Style 14 Gray",
        "description": {
          "Style": "style-14",
          "Color": "gray"
        }
      },
      {
        "value": "eyes_style-14-green",
        "displayName": "Style 14 Green",
        "description": {
          "Style": "style-14",
          "Color": "green"
        }
      },
      {
        "value": "eyes_style-14-hazel",
        "displayName": "Style 14 Hazel",
        "description": {
          "Style": "style-14",
          "Color": "hazel"
        }
      },
      {
        "value": "eyes_style-15-blue",
        "displayName": "Style 15 Blue",
        "description": {
          "Style": "style-15",
          "Color": "blue"
        }
      },
      {
        "value": "eyes_style-15-brown",
        "displayName": "Style 15 Brown",
        "description": {
          "Style": "style-15",
          "Color": "brown"
        }
      },
      {
        "value": "eyes_style-15-gray",
        "displayName": "Style 15 Gray",
        "description": {
          "Style": "style-15",
          "Color": "gray"
        }
      },
      {
        "value": "eyes_style-15-green",
        "displayName": "Style 15 Green",
        "description": {
          "Style": "style-15",
          "Color": "green"
        }
      },
      {
        "value": "eyes_style-15-hazel",
        "displayName": "Style 15 Hazel",
        "description": {
          "Style": "style-15",
          "Color": "hazel"
        }
      },
      {
        "value": "eyes_style-2-blue",
        "displayName": "Style 2 Blue",
        "description": {
          "Style": "style-2",
          "Color": "blue"
        }
      },
      {
        "value": "eyes_style-2-brown",
        "displayName": "Style 2 Brown",
        "description": {
          "Style": "style-2",
          "Color": "brown"
        }
      },
      {
        "value": "eyes_style-2-gray",
        "displayName": "Style 2 Gray",
        "description": {
          "Style": "style-2",
          "Color": "gray"
        }
      },
      {
        "value": "eyes_style-2-green",
        "displayName": "Style 2 Green",
        "description": {
          "Style": "style-2",
          "Color": "green"
        }
      },
      {
        "value": "eyes_style-2-hazel",
        "displayName": "Style 2 Hazel",
        "description": {
          "Style": "style-2",
          "Color": "hazel"
        }
      },
      {
        "value": "eyes_style-3-blue",
        "displayName": "Style 3 Blue",
        "description": {
          "Style": "style-3",
          "Color": "blue"
        }
      },
      {
        "value": "eyes_style-3-brown",
        "displayName": "Style 3 Brown",
        "description": {
          "Style": "style-3",
          "Color": "brown"
        }
      },
      {
        "value": "eyes_style-3-gray",
        "displayName": "Style 3 Gray",
        "description": {
          "Style": "style-3",
          "Color": "gray"
        }
      },
      {
        "value": "eyes_style-3-green",
        "displayName": "Style 3 Green",
        "description": {
          "Style": "style-3",
          "Color": "green"
        }
      },
      {
        "value": "eyes_style-3-hazel",
        "displayName": "Style 3 Hazel",
        "description": {
          "Style": "style-3",
          "Color": "hazel"
        }
      },
      {
        "value": "eyes_style-4-blue",
        "displayName": "Style 4 Blue",
        "description": {
          "Style": "style-4",
          "Color": "blue"
        }
      },
      {
        "value": "eyes_style-4-brown",
        "displayName": "Style 4 Brown",
        "description": {
          "Style": "style-4",
          "Color": "brown"
        }
      },
      {
        "value": "eyes_style-4-gray",
        "displayName": "Style 4 Gray",
        "description": {
          "Style": "style-4",
          "Color": "gray"
        }
      },
      {
        "value": "eyes_style-4-green",
        "displayName": "Style 4 Green",
        "description": {
          "Style": "style-4",
          "Color": "green"
        }
      },
      {
        "value": "eyes_style-4-hazel",
        "displayName": "Style 4 Hazel",
        "description": {
          "Style": "style-4",
          "Color": "hazel"
        }
      },
      {
        "value": "eyes_style-5-blue",
        "displayName": "Style 5 Blue",
        "description": {
          "Style": "style-5",
          "Color": "blue"
        }
      },
      {
        "value": "eyes_style-5-brown",
        "displayName": "Style 5 Brown",
        "description": {
          "Style": "style-5",
          "Color": "brown"
        }
      },
      {
        "value": "eyes_style-5-gray",
        "displayName": "Style 5 Gray",
        "description": {
          "Style": "style-5",
          "Color": "gray"
        }
      },
      {
        "value": "eyes_style-5-green",
        "displayName": "Style 5 Green",
        "description": {
          "Style": "style-5",
          "Color": "green"
        }
      },
      {
        "value": "eyes_style-5-hazel",
        "displayName": "Style 5 Hazel",
        "description": {
          "Style": "style-5",
          "Color": "hazel"
        }
      }
    ],
    "description": {
      "Style": {
        "options": [
          null,
          "style-1",
          "style-11",
          "style-12",
          "style-13",
          "style-14",
          "style-15",
          "style-2",
          "style-3",
          "style-4",
          "style-5"
        ],
        "isPrimaryOption": true
      },
      "Color": {
        "options": [
          "blue",
          "brown",
          "gray",
          "green",
          "hazel"
        ]
      }
    },
    "bisectInThumbnail": true
  },
  "Eyebrows": {
    "parts": [
      {
        "value": null,
        "displayName": "None",
        "excludeFromRandomize": true
      },
      {
        "value": "eyebrows_style-1-black",
        "displayName": "Style 1 Black",
        "description": {
          "Style": "style-1",
          "Color": "black"
        }
      },
      {
        "value": "eyebrows_style-1-blonde",
        "displayName": "Style 1 Blonde",
        "description": {
          "Style": "style-1",
          "Color": "blonde"
        }
      },
      {
        "value": "eyebrows_style-1-blue",
        "displayName": "Style 1 Blue",
        "description": {
          "Style": "style-1",
          "Color": "blue"
        }
      },
      {
        "value": "eyebrows_style-1-brown",
        "displayName": "Style 1 Brown",
        "description": {
          "Style": "style-1",
          "Color": "brown"
        }
      },
      {
        "value": "eyebrows_style-1-dark brown",
        "displayName": "Style 1 Dark brown",
        "description": {
          "Style": "style-1",
          "Color": "dark brown"
        }
      },
      {
        "value": "eyebrows_style-1-gray",
        "displayName": "Style 1 Gray",
        "description": {
          "Style": "style-1",
          "Color": "gray"
        }
      },
      {
        "value": "eyebrows_style-1-light brown",
        "displayName": "Style 1 Light brown",
        "description": {
          "Style": "style-1",
          "Color": "light brown"
        }
      },
      {
        "value": "eyebrows_style-1-pink",
        "displayName": "Style 1 Pink",
        "description": {
          "Style": "style-1",
          "Color": "pink"
        }
      },
      {
        "value": "eyebrows_style-1-red",
        "displayName": "Style 1 Red",
        "description": {
          "Style": "style-1",
          "Color": "red"
        }
      },
      {
        "value": "eyebrows_style-1-white",
        "displayName": "Style 1 White",
        "description": {
          "Style": "style-1",
          "Color": "white"
        }
      },
      {
        "value": "eyebrows_style-2-black",
        "displayName": "Style 2 Black",
        "description": {
          "Style": "style-2",
          "Color": "black"
        }
      },
      {
        "value": "eyebrows_style-2-blonde",
        "displayName": "Style 2 Blonde",
        "description": {
          "Style": "style-2",
          "Color": "blonde"
        }
      },
      {
        "value": "eyebrows_style-2-blue",
        "displayName": "Style 2 Blue",
        "description": {
          "Style": "style-2",
          "Color": "blue"
        }
      },
      {
        "value": "eyebrows_style-2-brown",
        "displayName": "Style 2 Brown",
        "description": {
          "Style": "style-2",
          "Color": "brown"
        }
      },
      {
        "value": "eyebrows_style-2-dark brown",
        "displayName": "Style 2 Dark brown",
        "description": {
          "Style": "style-2",
          "Color": "dark brown"
        }
      },
      {
        "value": "eyebrows_style-2-gray",
        "displayName": "Style 2 Gray",
        "description": {
          "Style": "style-2",
          "Color": "gray"
        }
      },
      {
        "value": "eyebrows_style-2-light brown",
        "displayName": "Style 2 Light brown",
        "description": {
          "Style": "style-2",
          "Color": "light brown"
        }
      },
      {
        "value": "eyebrows_style-2-pink",
        "displayName": "Style 2 Pink",
        "description": {
          "Style": "style-2",
          "Color": "pink"
        }
      },
      {
        "value": "eyebrows_style-2-red",
        "displayName": "Style 2 Red",
        "description": {
          "Style": "style-2",
          "Color": "red"
        }
      },
      {
        "value": "eyebrows_style-2-white",
        "displayName": "Style 2 White",
        "description": {
          "Style": "style-2",
          "Color": "white"
        }
      },
      {
        "value": "eyebrows_style-3-black",
        "displayName": "Style 3 Black",
        "description": {
          "Style": "style-3",
          "Color": "black"
        }
      },
      {
        "value": "eyebrows_style-3-blonde",
        "displayName": "Style 3 Blonde",
        "description": {
          "Style": "style-3",
          "Color": "blonde"
        }
      },
      {
        "value": "eyebrows_style-3-blue",
        "displayName": "Style 3 Blue",
        "description": {
          "Style": "style-3",
          "Color": "blue"
        }
      },
      {
        "value": "eyebrows_style-3-brown",
        "displayName": "Style 3 Brown",
        "description": {
          "Style": "style-3",
          "Color": "brown"
        }
      },
      {
        "value": "eyebrows_style-3-dark brown",
        "displayName": "Style 3 Dark brown",
        "description": {
          "Style": "style-3",
          "Color": "dark brown"
        }
      },
      {
        "value": "eyebrows_style-3-gray",
        "displayName": "Style 3 Gray",
        "description": {
          "Style": "style-3",
          "Color": "gray"
        }
      },
      {
        "value": "eyebrows_style-3-light brown",
        "displayName": "Style 3 Light brown",
        "description": {
          "Style": "style-3",
          "Color": "light brown"
        }
      },
      {
        "value": "eyebrows_style-3-pink",
        "displayName": "Style 3 Pink",
        "description": {
          "Style": "style-3",
          "Color": "pink"
        }
      },
      {
        "value": "eyebrows_style-3-red",
        "displayName": "Style 3 Red",
        "description": {
          "Style": "style-3",
          "Color": "red"
        }
      },
      {
        "value": "eyebrows_style-3-white",
        "displayName": "Style 3 White",
        "description": {
          "Style": "style-3",
          "Color": "white"
        }
      },
      {
        "value": "eyebrows_style-4-black",
        "displayName": "Style 4 Black",
        "description": {
          "Style": "style-4",
          "Color": "black"
        }
      },
      {
        "value": "eyebrows_style-4-blonde",
        "displayName": "Style 4 Blonde",
        "description": {
          "Style": "style-4",
          "Color": "blonde"
        }
      },
      {
        "value": "eyebrows_style-4-blue",
        "displayName": "Style 4 Blue",
        "description": {
          "Style": "style-4",
          "Color": "blue"
        }
      },
      {
        "value": "eyebrows_style-4-brown",
        "displayName": "Style 4 Brown",
        "description": {
          "Style": "style-4",
          "Color": "brown"
        }
      },
      {
        "value": "eyebrows_style-4-dark brown",
        "displayName": "Style 4 Dark brown",
        "description": {
          "Style": "style-4",
          "Color": "dark brown"
        }
      },
      {
        "value": "eyebrows_style-4-gray",
        "displayName": "Style 4 Gray",
        "description": {
          "Style": "style-4",
          "Color": "gray"
        }
      },
      {
        "value": "eyebrows_style-4-light brown",
        "displayName": "Style 4 Light brown",
        "description": {
          "Style": "style-4",
          "Color": "light brown"
        }
      },
      {
        "value": "eyebrows_style-4-pink",
        "displayName": "Style 4 Pink",
        "description": {
          "Style": "style-4",
          "Color": "pink"
        }
      },
      {
        "value": "eyebrows_style-4-red",
        "displayName": "Style 4 Red",
        "description": {
          "Style": "style-4",
          "Color": "red"
        }
      },
      {
        "value": "eyebrows_style-4-white",
        "displayName": "Style 4 White",
        "description": {
          "Style": "style-4",
          "Color": "white"
        }
      }
    ],
    "description": {
      "Style": {
        "options": [
          null,
          "style-1",
          "style-2",
          "style-3",
          "style-4"
        ],
        "isPrimaryOption": true
      },
      "Color": {
        "options": [
          "black",
          "blonde",
          "blue",
          "brown",
          "dark brown",
          "gray",
          "light brown",
          "pink",
          "red",
          "white"
        ]
      }
    },
    "bisectInThumbnail": true
  },
  "Mouth": {
    "parts": [
      {
        "value": null,
        "displayName": "None",
        "excludeFromRandomize": true
      },
      {
        "value": "mouth_neutral-skin-1",
        "displayName": "Neutral Skin 1",
        "description": {
          "Type": "neutral",
          "Skin Tone": "skin-1"
        }
      },
      {
        "value": "mouth_neutral-skin-2",
        "displayName": "Neutral Skin 2",
        "description": {
          "Type": "neutral",
          "Skin Tone": "skin-2"
        }
      },
      {
        "value": "mouth_neutral-skin-3",
        "displayName": "Neutral Skin 3",
        "description": {
          "Type": "neutral",
          "Skin Tone": "skin-3"
        }
      },
      {
        "value": "mouth_neutral-skin-4",
        "displayName": "Neutral Skin 4",
        "description": {
          "Type": "neutral",
          "Skin Tone": "skin-4"
        }
      },
      {
        "value": "mouth_neutral-skin-5",
        "displayName": "Neutral Skin 5",
        "description": {
          "Type": "neutral",
          "Skin Tone": "skin-5"
        }
      },
      {
        "value": "mouth_neutral-skin-6",
        "displayName": "Neutral Skin 6",
        "description": {
          "Type": "neutral",
          "Skin Tone": "skin-6"
        }
      },
      {
        "value": "mouth_neutral-skin-7",
        "displayName": "Neutral Skin 7",
        "description": {
          "Type": "neutral",
          "Skin Tone": "skin-7"
        }
      },
      {
        "value": "mouth_neutral-skin-8",
        "displayName": "Neutral Skin 8",
        "description": {
          "Type": "neutral",
          "Skin Tone": "skin-8"
        }
      },
      {
        "value": "mouth_neutral-skin-a",
        "displayName": "Neutral Skin A",
        "description": {
          "Type": "neutral",
          "Skin Tone": "skin-a"
        }
      },
      {
        "value": "mouth_neutral-skin-b",
        "displayName": "Neutral Skin B",
        "description": {
          "Type": "neutral",
          "Skin Tone": "skin-b"
        }
      },
      {
        "value": "mouth_neutral-skin-c",
        "displayName": "Neutral Skin C",
        "description": {
          "Type": "neutral",
          "Skin Tone": "skin-c"
        }
      },
      {
        "value": "mouth_neutral-skin-d",
        "displayName": "Neutral Skin D",
        "description": {
          "Type": "neutral",
          "Skin Tone": "skin-d"
        }
      },
      {
        "value": "mouth_neutral-skin-e",
        "displayName": "Neutral Skin E",
        "description": {
          "Type": "neutral",
          "Skin Tone": "skin-e"
        }
      },
      {
        "value": "mouth_neutral-skin-f",
        "displayName": "Neutral Skin F",
        "description": {
          "Type": "neutral",
          "Skin Tone": "skin-f"
        }
      },
      {
        "value": "mouth_neutral-skin-g",
        "displayName": "Neutral Skin G",
        "description": {
          "Type": "neutral",
          "Skin Tone": "skin-g"
        }
      },
      {
        "value": "mouth_neutral-skin-h",
        "displayName": "Neutral Skin H",
        "description": {
          "Type": "neutral",
          "Skin Tone": "skin-h"
        }
      },
      {
        "value": "mouth_smirk-skin-1",
        "displayName": "Smirk Skin 1",
        "description": {
          "Type": "smirk",
          "Skin Tone": "skin-1"
        }
      },
      {
        "value": "mouth_smirk-skin-2",
        "displayName": "Smirk Skin 2",
        "description": {
          "Type": "smirk",
          "Skin Tone": "skin-2"
        }
      },
      {
        "value": "mouth_smirk-skin-3",
        "displayName": "Smirk Skin 3",
        "description": {
          "Type": "smirk",
          "Skin Tone": "skin-3"
        }
      },
      {
        "value": "mouth_smirk-skin-4",
        "displayName": "Smirk Skin 4",
        "description": {
          "Type": "smirk",
          "Skin Tone": "skin-4"
        }
      },
      {
        "value": "mouth_smirk-skin-5",
        "displayName": "Smirk Skin 5",
        "description": {
          "Type": "smirk",
          "Skin Tone": "skin-5"
        }
      },
      {
        "value": "mouth_smirk-skin-6",
        "displayName": "Smirk Skin 6",
        "description": {
          "Type": "smirk",
          "Skin Tone": "skin-6"
        }
      },
      {
        "value": "mouth_smirk-skin-7",
        "displayName": "Smirk Skin 7",
        "description": {
          "Type": "smirk",
          "Skin Tone": "skin-7"
        }
      },
      {
        "value": "mouth_smirk-skin-8",
        "displayName": "Smirk Skin 8",
        "description": {
          "Type": "smirk",
          "Skin Tone": "skin-8"
        }
      },
      {
        "value": "mouth_smirk-skin-a",
        "displayName": "Smirk Skin A",
        "description": {
          "Type": "smirk",
          "Skin Tone": "skin-a"
        }
      },
      {
        "value": "mouth_smirk-skin-b",
        "displayName": "Smirk Skin B",
        "description": {
          "Type": "smirk",
          "Skin Tone": "skin-b"
        }
      },
      {
        "value": "mouth_smirk-skin-c",
        "displayName": "Smirk Skin C",
        "description": {
          "Type": "smirk",
          "Skin Tone": "skin-c"
        }
      },
      {
        "value": "mouth_smirk-skin-d",
        "displayName": "Smirk Skin D",
        "description": {
          "Type": "smirk",
          "Skin Tone": "skin-d"
        }
      },
      {
        "value": "mouth_smirk-skin-e",
        "displayName": "Smirk Skin E",
        "description": {
          "Type": "smirk",
          "Skin Tone": "skin-e"
        }
      },
      {
        "value": "mouth_smirk-skin-f",
        "displayName": "Smirk Skin F",
        "description": {
          "Type": "smirk",
          "Skin Tone": "skin-f"
        }
      },
      {
        "value": "mouth_smirk-skin-g",
        "displayName": "Smirk Skin G",
        "description": {
          "Type": "smirk",
          "Skin Tone": "skin-g"
        }
      },
      {
        "value": "mouth_smirk-skin-h",
        "displayName": "Smirk Skin H",
        "description": {
          "Type": "smirk",
          "Skin Tone": "skin-h"
        }
      }
    ],
    "description": {
      "Type": {
        "options": [
          null,
          "neutral",
          "smirk"
        ],
        "isPrimaryOption": true
      },
      "Skin Tone": {
        "options": [
          "skin-1",
          "skin-2",
          "skin-3",
          "skin-4",
          "skin-5",
          "skin-6",
          "skin-7",
          "skin-8",
          "skin-a",
          "skin-b",
          "skin-c",
          "skin-d",
          "skin-e",
          "skin-f",
          "skin-g",
          "skin-h"
        ]
      }
    }
  },
  "Facial Hair": {
    "parts": [
      {
        "value": null,
        "displayName": "None",
        "excludeFromRandomize": false,
        "randomizationWeight": 59
      },
      {
        "value": "facial-hair_beard-full-1-black",
        "displayName": "Beard Full 1 Black",
        "description": {
          "Type": "beard-full-1",
          "Color": "black"
        }
      },
      {
        "value": "facial-hair_beard-full-1-blonde",
        "displayName": "Beard Full 1 Blonde",
        "description": {
          "Type": "beard-full-1",
          "Color": "blonde"
        }
      },
      {
        "value": "facial-hair_beard-full-1-brown",
        "displayName": "Beard Full 1 Brown",
        "description": {
          "Type": "beard-full-1",
          "Color": "brown"
        }
      },
      {
        "value": "facial-hair_beard-full-1-dark brown",
        "displayName": "Beard Full 1 Dark brown",
        "description": {
          "Type": "beard-full-1",
          "Color": "dark brown"
        }
      },
      {
        "value": "facial-hair_beard-full-1-gray",
        "displayName": "Beard Full 1 Gray",
        "description": {
          "Type": "beard-full-1",
          "Color": "gray"
        }
      },
      {
        "value": "facial-hair_beard-full-1-light brown",
        "displayName": "Beard Full 1 Light brown",
        "description": {
          "Type": "beard-full-1",
          "Color": "light brown"
        }
      },
      {
        "value": "facial-hair_beard-full-1-red",
        "displayName": "Beard Full 1 Red",
        "description": {
          "Type": "beard-full-1",
          "Color": "red"
        }
      },
      {
        "value": "facial-hair_beard-full-1-white",
        "displayName": "Beard Full 1 White",
        "description": {
          "Type": "beard-full-1",
          "Color": "white"
        }
      },
      {
        "value": "facial-hair_beard-full-2-black",
        "displayName": "Beard Full 2 Black",
        "description": {
          "Type": "beard-full-2",
          "Color": "black"
        }
      },
      {
        "value": "facial-hair_beard-full-2-blonde",
        "displayName": "Beard Full 2 Blonde",
        "description": {
          "Type": "beard-full-2",
          "Color": "blonde"
        }
      },
      {
        "value": "facial-hair_beard-full-2-brown",
        "displayName": "Beard Full 2 Brown",
        "description": {
          "Type": "beard-full-2",
          "Color": "brown"
        }
      },
      {
        "value": "facial-hair_beard-full-2-dark brown",
        "displayName": "Beard Full 2 Dark brown",
        "description": {
          "Type": "beard-full-2",
          "Color": "dark brown"
        }
      },
      {
        "value": "facial-hair_beard-full-2-gray",
        "displayName": "Beard Full 2 Gray",
        "description": {
          "Type": "beard-full-2",
          "Color": "gray"
        }
      },
      {
        "value": "facial-hair_beard-full-2-light brown",
        "displayName": "Beard Full 2 Light brown",
        "description": {
          "Type": "beard-full-2",
          "Color": "light brown"
        }
      },
      {
        "value": "facial-hair_beard-full-2-red",
        "displayName": "Beard Full 2 Red",
        "description": {
          "Type": "beard-full-2",
          "Color": "red"
        }
      },
      {
        "value": "facial-hair_beard-full-2-white",
        "displayName": "Beard Full 2 White",
        "description": {
          "Type": "beard-full-2",
          "Color": "white"
        }
      },
      {
        "value": "facial-hair_goatee-1-black",
        "displayName": "Goatee 1 Black",
        "description": {
          "Type": "goatee-1",
          "Color": "black"
        }
      },
      {
        "value": "facial-hair_goatee-1-blonde",
        "displayName": "Goatee 1 Blonde",
        "description": {
          "Type": "goatee-1",
          "Color": "blonde"
        }
      },
      {
        "value": "facial-hair_goatee-1-brown",
        "displayName": "Goatee 1 Brown",
        "description": {
          "Type": "goatee-1",
          "Color": "brown"
        }
      },
      {
        "value": "facial-hair_goatee-1-dark brown",
        "displayName": "Goatee 1 Dark brown",
        "description": {
          "Type": "goatee-1",
          "Color": "dark brown"
        }
      },
      {
        "value": "facial-hair_goatee-1-gray",
        "displayName": "Goatee 1 Gray",
        "description": {
          "Type": "goatee-1",
          "Color": "gray"
        }
      },
      {
        "value": "facial-hair_goatee-1-light brown",
        "displayName": "Goatee 1 Light brown",
        "description": {
          "Type": "goatee-1",
          "Color": "light brown"
        }
      },
      {
        "value": "facial-hair_goatee-1-red",
        "displayName": "Goatee 1 Red",
        "description": {
          "Type": "goatee-1",
          "Color": "red"
        }
      },
      {
        "value": "facial-hair_goatee-1-white",
        "displayName": "Goatee 1 White",
        "description": {
          "Type": "goatee-1",
          "Color": "white"
        }
      },
      {
        "value": "facial-hair_goatee-2-brown",
        "displayName": "Goatee 2 Brown",
        "description": {
          "Type": "goatee-2",
          "Color": "brown"
        }
      },
      {
        "value": "facial-hair_goatee-3-black",
        "displayName": "Goatee 3 Black",
        "description": {
          "Type": "goatee-3",
          "Color": "black"
        }
      },
      {
        "value": "facial-hair_goatee-3-blonde",
        "displayName": "Goatee 3 Blonde",
        "description": {
          "Type": "goatee-3",
          "Color": "blonde"
        }
      },
      {
        "value": "facial-hair_goatee-3-brown",
        "displayName": "Goatee 3 Brown",
        "description": {
          "Type": "goatee-3",
          "Color": "brown"
        }
      },
      {
        "value": "facial-hair_goatee-3-dark brown",
        "displayName": "Goatee 3 Dark brown",
        "description": {
          "Type": "goatee-3",
          "Color": "dark brown"
        }
      },
      {
        "value": "facial-hair_goatee-3-gray",
        "displayName": "Goatee 3 Gray",
        "description": {
          "Type": "goatee-3",
          "Color": "gray"
        }
      },
      {
        "value": "facial-hair_goatee-3-light brown",
        "displayName": "Goatee 3 Light brown",
        "description": {
          "Type": "goatee-3",
          "Color": "light brown"
        }
      },
      {
        "value": "facial-hair_goatee-3-red",
        "displayName": "Goatee 3 Red",
        "description": {
          "Type": "goatee-3",
          "Color": "red"
        }
      },
      {
        "value": "facial-hair_goatee-3-white",
        "displayName": "Goatee 3 White",
        "description": {
          "Type": "goatee-3",
          "Color": "white"
        }
      },
      {
        "value": "facial-hair_goatee-4-black",
        "displayName": "Goatee 4 Black",
        "description": {
          "Type": "goatee-4",
          "Color": "black"
        }
      },
      {
        "value": "facial-hair_goatee-4-blonde",
        "displayName": "Goatee 4 Blonde",
        "description": {
          "Type": "goatee-4",
          "Color": "blonde"
        }
      },
      {
        "value": "facial-hair_goatee-4-brown",
        "displayName": "Goatee 4 Brown",
        "description": {
          "Type": "goatee-4",
          "Color": "brown"
        }
      },
      {
        "value": "facial-hair_goatee-4-dark brown",
        "displayName": "Goatee 4 Dark brown",
        "description": {
          "Type": "goatee-4",
          "Color": "dark brown"
        }
      },
      {
        "value": "facial-hair_goatee-4-gray",
        "displayName": "Goatee 4 Gray",
        "description": {
          "Type": "goatee-4",
          "Color": "gray"
        }
      },
      {
        "value": "facial-hair_goatee-4-light brown",
        "displayName": "Goatee 4 Light brown",
        "description": {
          "Type": "goatee-4",
          "Color": "light brown"
        }
      },
      {
        "value": "facial-hair_goatee-4-red",
        "displayName": "Goatee 4 Red",
        "description": {
          "Type": "goatee-4",
          "Color": "red"
        }
      },
      {
        "value": "facial-hair_goatee-4-white",
        "displayName": "Goatee 4 White",
        "description": {
          "Type": "goatee-4",
          "Color": "white"
        }
      },
      {
        "value": "facial-hair_goatee-5-brown",
        "displayName": "Goatee 5 Brown",
        "description": {
          "Type": "goatee-5",
          "Color": "brown"
        }
      },
      {
        "value": "facial-hair_mustache-1-black",
        "displayName": "Mustache 1 Black",
        "description": {
          "Type": "mustache-1",
          "Color": "black"
        }
      },
      {
        "value": "facial-hair_mustache-1-blonde",
        "displayName": "Mustache 1 Blonde",
        "description": {
          "Type": "mustache-1",
          "Color": "blonde"
        }
      },
      {
        "value": "facial-hair_mustache-1-brown",
        "displayName": "Mustache 1 Brown",
        "description": {
          "Type": "mustache-1",
          "Color": "brown"
        }
      },
      {
        "value": "facial-hair_mustache-1-dark brown",
        "displayName": "Mustache 1 Dark brown",
        "description": {
          "Type": "mustache-1",
          "Color": "dark brown"
        }
      },
      {
        "value": "facial-hair_mustache-1-gray",
        "displayName": "Mustache 1 Gray",
        "description": {
          "Type": "mustache-1",
          "Color": "gray"
        }
      },
      {
        "value": "facial-hair_mustache-1-light brown",
        "displayName": "Mustache 1 Light brown",
        "description": {
          "Type": "mustache-1",
          "Color": "light brown"
        }
      },
      {
        "value": "facial-hair_mustache-1-red",
        "displayName": "Mustache 1 Red",
        "description": {
          "Type": "mustache-1",
          "Color": "red"
        }
      },
      {
        "value": "facial-hair_mustache-1-white",
        "displayName": "Mustache 1 White",
        "description": {
          "Type": "mustache-1",
          "Color": "white"
        }
      },
      {
        "value": "facial-hair_mustache-2-black",
        "displayName": "Mustache 2 Black",
        "description": {
          "Type": "mustache-2",
          "Color": "black"
        }
      },
      {
        "value": "facial-hair_mustache-2-blonde",
        "displayName": "Mustache 2 Blonde",
        "description": {
          "Type": "mustache-2",
          "Color": "blonde"
        }
      },
      {
        "value": "facial-hair_mustache-2-brown",
        "displayName": "Mustache 2 Brown",
        "description": {
          "Type": "mustache-2",
          "Color": "brown"
        }
      },
      {
        "value": "facial-hair_mustache-2-dark brown",
        "displayName": "Mustache 2 Dark brown",
        "description": {
          "Type": "mustache-2",
          "Color": "dark brown"
        }
      },
      {
        "value": "facial-hair_mustache-2-gray",
        "displayName": "Mustache 2 Gray",
        "description": {
          "Type": "mustache-2",
          "Color": "gray"
        }
      },
      {
        "value": "facial-hair_mustache-2-light brown",
        "displayName": "Mustache 2 Light brown",
        "description": {
          "Type": "mustache-2",
          "Color": "light brown"
        }
      },
      {
        "value": "facial-hair_mustache-2-red",
        "displayName": "Mustache 2 Red",
        "description": {
          "Type": "mustache-2",
          "Color": "red"
        }
      },
      {
        "value": "facial-hair_mustache-2-white",
        "displayName": "Mustache 2 White",
        "description": {
          "Type": "mustache-2",
          "Color": "white"
        }
      }
    ],
    "description": {
      "Type": {
        "options": [
          null,
          "beard-full-1",
          "beard-full-2",
          "goatee-1",
          "goatee-2",
          "goatee-3",
          "goatee-4",
          "goatee-5",
          "mustache-1",
          "mustache-2"
        ],
        "isPrimaryOption": true
      },
      "Color": {
        "options": [
          "black",
          "blonde",
          "brown",
          "dark brown",
          "gray",
          "light brown",
          "red",
          "white"
        ]
      }
    }
  },
  "Hands": {
    "parts": [
      {
        "value": null,
        "displayName": "None",
        "excludeFromRandomize": true
      },
      {
        "value": "hands_skin-1",
        "displayName": "Skin 1"
      },
      {
        "value": "hands_skin-2",
        "displayName": "Skin 2"
      },
      {
        "value": "hands_skin-3",
        "displayName": "Skin 3"
      },
      {
        "value": "hands_skin-4",
        "displayName": "Skin 4"
      },
      {
        "value": "hands_skin-5",
        "displayName": "Skin 5"
      },
      {
        "value": "hands_skin-6",
        "displayName": "Skin 6"
      },
      {
        "value": "hands_skin-7",
        "displayName": "Skin 7"
      },
      {
        "value": "hands_skin-8",
        "displayName": "Skin 8"
      },
      {
        "value": "hands_skin-a",
        "displayName": "Skin A"
      },
      {
        "value": "hands_skin-b",
        "displayName": "Skin B"
      },
      {
        "value": "hands_skin-c",
        "displayName": "Skin C"
      },
      {
        "value": "hands_skin-d",
        "displayName": "Skin D"
      },
      {
        "value": "hands_skin-e",
        "displayName": "Skin E"
      },
      {
        "value": "hands_skin-f",
        "displayName": "Skin F"
      },
      {
        "value": "hands_skin-g",
        "displayName": "Skin G"
      },
      {
        "value": "hands_skin-h",
        "displayName": "Skin H"
      }
    ],
    "bisectInThumbnail": true
  },
  "Torso": {
    "parts": [
      {
        "value": null,
        "displayName": "None",
        "excludeFromRandomize": true
      },
      {
        "value": "torso_style-1-bowling-shirt-1-red",
        "displayName": "Style 1 Bowling Shirt 1 Red",
        "description": {
          "Type": "style-1",
          "Outfit": "bowling-shirt-1-red"
        },
        "matchRandomizationToNull": true
      },
      {
        "value": "torso_style-1-combat-vest-red",
        "displayName": "Style 1 Combat Vest Red",
        "description": {
          "Type": "style-1",
          "Outfit": "combat-vest-red"
        },
        "matchRandomizationToNull": true
      },
      {
        "value": "torso_style-1-sport-coat-1-dark",
        "displayName": "Style 1 Sport Coat 1 Dark",
        "description": {
          "Type": "style-1",
          "Outfit": "sport-coat-1-dark"
        },
        "matchRandomizationToNull": true
      },
      {
        "value": "torso_style-1-sport-coat-1-gray",
        "displayName": "Style 1 Sport Coat 1 Gray",
        "description": {
          "Type": "style-1",
          "Outfit": "sport-coat-1-gray"
        },
        "matchRandomizationToNull": true
      },
      {
        "value": "torso_style-1-tshirt-1-hubs-black",
        "displayName": "Style 1 Tshirt 1 Hubs Black",
        "description": {
          "Type": "style-1",
          "Outfit": "tshirt-1-hubs-black"
        }
      },
      {
        "value": "torso_style-1-tshirt-1-hubs-gray",
        "displayName": "Style 1 Tshirt 1 Hubs Gray",
        "description": {
          "Type": "style-1",
          "Outfit": "tshirt-1-hubs-gray"
        }
      },
      {
        "value": "torso_style-1-tshirt-1-hubs-light-gray",
        "displayName": "Style 1 Tshirt 1 Hubs Light Gray",
        "description": {
          "Type": "style-1",
          "Outfit": "tshirt-1-hubs-light-gray"
        }
      },
      {
        "value": "torso_style-1-tshirt-1-hubs-white",
        "displayName": "Style 1 Tshirt 1 Hubs White",
        "description": {
          "Type": "style-1",
          "Outfit": "tshirt-1-hubs-white"
        }
      },
      {
        "value": "torso_style-1-tshirt-1-moz",
        "displayName": "Style 1 Tshirt 1 Moz",
        "description": {
          "Type": "style-1",
          "Outfit": "tshirt-1-moz"
        }
      },
      {
        "value": "torso_style-1-tshirt-1-union-jack",
        "displayName": "Style 1 Tshirt 1 Union Jack",
        "description": {
          "Type": "style-1",
          "Outfit": "tshirt-1-union-jack"
        }
      },
      {
        "value": "torso_style-1-tshirt-pride01",
        "displayName": "Style 1 Tshirt Pride01",
        "description": {
          "Type": "style-1",
          "Outfit": "tshirt-pride01"
        }
      },
      {
        "value": "torso_style-1-tshirt-pride02",
        "displayName": "Style 1 Tshirt Pride02",
        "description": {
          "Type": "style-1",
          "Outfit": "tshirt-pride02"
        }
      },
      {
        "value": "torso_style-1-tshirt-pride03",
        "displayName": "Style 1 Tshirt Pride03",
        "description": {
          "Type": "style-1",
          "Outfit": "tshirt-pride03"
        }
      },
      {
        "value": "torso_style-1-tshirt1-reactor",
        "displayName": "Style 1 Tshirt1 Reactor",
        "description": {
          "Type": "style-1",
          "Outfit": "tshirt1-reactor"
        }
      },
      {
        "value": "torso_style-1-ugly-christmas-1",
        "displayName": "Style 1 Ugly Christmas 1",
        "description": {
          "Type": "style-1",
          "Outfit": "ugly-christmas-1"
        },
        "matchRandomizationToNull": true
      },
      {
        "value": "torso_style-1-waistcoat-and-cravat",
        "displayName": "Style 1 Waistcoat And Cravat",
        "description": {
          "Type": "style-1",
          "Outfit": "waistcoat-and-cravat"
        },
        "matchRandomizationToNull": true
      },
      {
        "value": "torso_style-2-blouse-1-purple",
        "displayName": "Style 2 Blouse 1 Purple",
        "description": {
          "Type": "style-2",
          "Outfit": "blouse-1-purple"
        }
      },
      {
        "value": "torso_style-2-tshirt-1-baby-unicorn",
        "displayName": "Style 2 Tshirt 1 Baby Unicorn",
        "description": {
          "Type": "style-2",
          "Outfit": "tshirt-1-baby-unicorn"
        }
      },
      {
        "value": "torso_style-2-tshirt-1-heart-animated",
        "displayName": "Style 2 Tshirt 1 Heart Animated",
        "description": {
          "Type": "style-2",
          "Outfit": "tshirt-1-heart-animated"
        }
      },
      {
        "value": "torso_style-2-tshirt-1-heart",
        "displayName": "Style 2 Tshirt 1 Heart",
        "description": {
          "Type": "style-2",
          "Outfit": "tshirt-1-heart"
        }
      },
      {
        "value": "torso_style-2-tshirt-1-hubs-black",
        "displayName": "Style 2 Tshirt 1 Hubs Black",
        "description": {
          "Type": "style-2",
          "Outfit": "tshirt-1-hubs-black"
        }
      },
      {
        "value": "torso_style-2-tshirt-1-hubs-gray",
        "displayName": "Style 2 Tshirt 1 Hubs Gray",
        "description": {
          "Type": "style-2",
          "Outfit": "tshirt-1-hubs-gray"
        }
      },
      {
        "value": "torso_style-2-tshirt-1-hubs-light-gray",
        "displayName": "Style 2 Tshirt 1 Hubs Light Gray",
        "description": {
          "Type": "style-2",
          "Outfit": "tshirt-1-hubs-light-gray"
        }
      },
      {
        "value": "torso_style-2-tshirt-1-hubs-white",
        "displayName": "Style 2 Tshirt 1 Hubs White",
        "description": {
          "Type": "style-2",
          "Outfit": "tshirt-1-hubs-white"
        }
      },
      {
        "value": "torso_style-2-tshirt-1-moz",
        "displayName": "Style 2 Tshirt 1 Moz",
        "description": {
          "Type": "style-2",
          "Outfit": "tshirt-1-moz"
        }
      },
      {
        "value": "torso_style-2-tshirt-pride01",
        "displayName": "Style 2 Tshirt Pride01",
        "description": {
          "Type": "style-2",
          "Outfit": "tshirt-pride01"
        }
      },
      {
        "value": "torso_style-2-tshirt-pride02",
        "displayName": "Style 2 Tshirt Pride02",
        "description": {
          "Type": "style-2",
          "Outfit": "tshirt-pride02"
        }
      },
      {
        "value": "torso_style-2-tshirt-pride03",
        "displayName": "Style 2 Tshirt Pride03",
        "description": {
          "Type": "style-2",
          "Outfit": "tshirt-pride03"
        }
      },
      {
        "value": "torso_style-2-tshirt-union-jack",
        "displayName": "Style 2 Tshirt Union Jack",
        "description": {
          "Type": "style-2",
          "Outfit": "tshirt-union-jack"
        }
      },
      {
        "value": "torso_style-2-tshirt1-reactor",
        "displayName": "Style 2 Tshirt1 Reactor",
        "description": {
          "Type": "style-2",
          "Outfit": "tshirt1-reactor"
        }
      }
    ],
    "description": {
      "Type": {
        "options": [
          null,
          "style-1",
          "style-2"
        ],
        "isPrimaryOption": true
      },
      "Outfit": {
        "options": [
          "bowling-shirt-1-red",
          "combat-vest-red",
          "sport-coat-1-dark",
          "sport-coat-1-gray",
          "tshirt-1-hubs-black",
          "tshirt-1-hubs-gray",
          "tshirt-1-hubs-light-gray",
          "tshirt-1-hubs-white",
          "tshirt-1-moz",
          "tshirt-1-union-jack",
          "tshirt-pride01",
          "tshirt-pride02",
          "tshirt-pride03",
          "tshirt1-reactor",
          "ugly-christmas-1",
          "waistcoat-and-cravat",
          "blouse-1-purple",
          "tshirt-1-baby-unicorn",
          "tshirt-1-heart-animated",
          "tshirt-1-heart",
          "tshirt-union-jack"
        ]
      }
    }
  },
  "Torso Jacket": {
    "parts": [
      {
        "value": null,
        "displayName": "None",
        "excludeFromRandomize": false,
        "randomizationWeight": 25
      },
      {
        "value": "torso-jacket_style-1-hoodie-1-black",
        "displayName": "Style 1 Hoodie 1 Black",
        "description": {
          "Type": "style-1",
          "Outfit": "hoodie-1-black"
        }
      },
      {
        "value": "torso-jacket_style-1-hoodie-1-blue",
        "displayName": "Style 1 Hoodie 1 Blue",
        "description": {
          "Type": "style-1",
          "Outfit": "hoodie-1-blue"
        }
      },
      {
        "value": "torso-jacket_style-1-hoodie-1-gray",
        "displayName": "Style 1 Hoodie 1 Gray",
        "description": {
          "Type": "style-1",
          "Outfit": "hoodie-1-gray"
        }
      },
      {
        "value": "torso-jacket_style-1-hoodie-1-green",
        "displayName": "Style 1 Hoodie 1 Green",
        "description": {
          "Type": "style-1",
          "Outfit": "hoodie-1-green"
        }
      },
      {
        "value": "torso-jacket_style-1-hoodie-1-light-gray",
        "displayName": "Style 1 Hoodie 1 Light Gray",
        "description": {
          "Type": "style-1",
          "Outfit": "hoodie-1-light-gray"
        }
      },
      {
        "value": "torso-jacket_style-1-hoodie-1-red",
        "displayName": "Style 1 Hoodie 1 Red",
        "description": {
          "Type": "style-1",
          "Outfit": "hoodie-1-red"
        }
      },
      {
        "value": "torso-jacket_style-1-punk-leather-1-black",
        "displayName": "Style 1 Punk Leather 1 Black",
        "description": {
          "Type": "style-1",
          "Outfit": "punk-leather-1-black"
        }
      },
      {
        "value": "torso-jacket_style-1-punk-leather-1-blue",
        "displayName": "Style 1 Punk Leather 1 Blue",
        "description": {
          "Type": "style-1",
          "Outfit": "punk-leather-1-blue"
        }
      },
      {
        "value": "torso-jacket_style-1-punk-leather-1-brown",
        "displayName": "Style 1 Punk Leather 1 Brown",
        "description": {
          "Type": "style-1",
          "Outfit": "punk-leather-1-brown"
        }
      },
      {
        "value": "torso-jacket_style-1-punk-leather-1-cognac",
        "displayName": "Style 1 Punk Leather 1 Cognac",
        "description": {
          "Type": "style-1",
          "Outfit": "punk-leather-1-cognac"
        }
      },
      {
        "value": "torso-jacket_style-1-punk-leather-1-maroon",
        "displayName": "Style 1 Punk Leather 1 Maroon",
        "description": {
          "Type": "style-1",
          "Outfit": "punk-leather-1-maroon"
        }
      },
      {
        "value": "torso-jacket_style-1-punk-leather-1-red",
        "displayName": "Style 1 Punk Leather 1 Red",
        "description": {
          "Type": "style-1",
          "Outfit": "punk-leather-1-red"
        }
      },
      {
        "value": "torso-jacket_style-2-hoodie-1-black",
        "displayName": "Style 2 Hoodie 1 Black",
        "description": {
          "Type": "style-2",
          "Outfit": "hoodie-1-black"
        }
      },
      {
        "value": "torso-jacket_style-2-hoodie-1-blue",
        "displayName": "Style 2 Hoodie 1 Blue",
        "description": {
          "Type": "style-2",
          "Outfit": "hoodie-1-blue"
        }
      },
      {
        "value": "torso-jacket_style-2-hoodie-1-gray",
        "displayName": "Style 2 Hoodie 1 Gray",
        "description": {
          "Type": "style-2",
          "Outfit": "hoodie-1-gray"
        }
      },
      {
        "value": "torso-jacket_style-2-hoodie-1-light-gray",
        "displayName": "Style 2 Hoodie 1 Light Gray",
        "description": {
          "Type": "style-2",
          "Outfit": "hoodie-1-light-gray"
        }
      },
      {
        "value": "torso-jacket_style-2-hoodie-1-pink",
        "displayName": "Style 2 Hoodie 1 Pink",
        "description": {
          "Type": "style-2",
          "Outfit": "hoodie-1-pink"
        }
      },
      {
        "value": "torso-jacket_style-2-hoodie-1-purple",
        "displayName": "Style 2 Hoodie 1 Purple",
        "description": {
          "Type": "style-2",
          "Outfit": "hoodie-1-purple"
        }
      },
      {
        "value": "torso-jacket_style-2-punk-leather-1-black",
        "displayName": "Style 2 Punk Leather 1 Black",
        "description": {
          "Type": "style-2",
          "Outfit": "punk-leather-1-black"
        }
      },
      {
        "value": "torso-jacket_style-2-punk-leather-1-blue",
        "displayName": "Style 2 Punk Leather 1 Blue",
        "description": {
          "Type": "style-2",
          "Outfit": "punk-leather-1-blue"
        }
      },
      {
        "value": "torso-jacket_style-2-punk-leather-1-brown",
        "displayName": "Style 2 Punk Leather 1 Brown",
        "description": {
          "Type": "style-2",
          "Outfit": "punk-leather-1-brown"
        }
      },
      {
        "value": "torso-jacket_style-2-punk-leather-1-cognac",
        "displayName": "Style 2 Punk Leather 1 Cognac",
        "description": {
          "Type": "style-2",
          "Outfit": "punk-leather-1-cognac"
        }
      },
      {
        "value": "torso-jacket_style-2-punk-leather-1-maroon",
        "displayName": "Style 2 Punk Leather 1 Maroon",
        "description": {
          "Type": "style-2",
          "Outfit": "punk-leather-1-maroon"
        }
      },
      {
        "value": "torso-jacket_style-2-punk-leather-1-red",
        "displayName": "Style 2 Punk Leather 1 Red",
        "description": {
          "Type": "style-2",
          "Outfit": "punk-leather-1-red"
        }
      }
    ],
    "description": {
      "Type": {
        "options": [
          null,
          "style-1",
          "style-2"
        ],
        "isPrimaryOption": true
      },
      "Outfit": {
        "options": [
          "hoodie-1-black",
          "hoodie-1-blue",
          "hoodie-1-gray",
          "hoodie-1-green",
          "hoodie-1-light-gray",
          "hoodie-1-red",
          "punk-leather-1-black",
          "punk-leather-1-blue",
          "punk-leather-1-brown",
          "punk-leather-1-cognac",
          "punk-leather-1-maroon",
          "punk-leather-1-red",
          "hoodie-1-pink",
          "hoodie-1-purple"
        ]
      }
    },
    "matchRandomization": {
      "categoryName": "Torso",
      "primaryOption": "Type",
      "secondaryOption": "Outfit"
    }
  },
  "Headwear": {
    "parts": [
      {
        "value": null,
        "displayName": "None",
        "excludeFromRandomize": false,
        "randomizationWeight": 20
      },
      {
        "value": "headwear_beach-umbrella-mixed",
        "displayName": "Beach Umbrella Mixed",
        "description": {
          "Type": "beach-umbrella",
          "Color": "mixed"
        }
      },
      {
        "value": "headwear_beanie-1-red",
        "displayName": "Beanie 1 Red",
        "description": {
          "Type": "beanie-1",
          "Color": "red"
        }
      },
      {
        "value": "headwear_hijab-black",
        "displayName": "Hijab Black",
        "description": {
          "Type": "hijab",
          "Color": "black"
        },
        "morphRelationships": [
          {
            "targetCategoryName": "Head",
            "targetMorphName": "ear rotate back",
            "targetMorphValue": 1
          }
        ],
        "randomizationWeight": 0.05
      },
      {
        "value": "headwear_hijab-blue",
        "displayName": "Hijab Blue",
        "description": {
          "Type": "hijab",
          "Color": "blue"
        },
        "morphRelationships": [
          {
            "targetCategoryName": "Head",
            "targetMorphName": "ear rotate back",
            "targetMorphValue": 1
          }
        ],
        "randomizationWeight": 0.05
      },
      {
        "value": "headwear_hijab-gray",
        "displayName": "Hijab Gray",
        "description": {
          "Type": "hijab",
          "Color": "gray"
        },
        "morphRelationships": [
          {
            "targetCategoryName": "Head",
            "targetMorphName": "ear rotate back",
            "targetMorphValue": 1
          }
        ],
        "randomizationWeight": 0.05
      },
      {
        "value": "headwear_hijab-lavender",
        "displayName": "Hijab Lavender",
        "description": {
          "Type": "hijab",
          "Color": "lavender"
        },
        "morphRelationships": [
          {
            "targetCategoryName": "Head",
            "targetMorphName": "ear rotate back",
            "targetMorphValue": 1
          }
        ],
        "randomizationWeight": 0.05
      },
      {
        "value": "headwear_hijab-pink",
        "displayName": "Hijab Pink",
        "description": {
          "Type": "hijab",
          "Color": "pink"
        },
        "morphRelationships": [
          {
            "targetCategoryName": "Head",
            "targetMorphName": "ear rotate back",
            "targetMorphValue": 1
          }
        ],
        "randomizationWeight": 0.05
      },
      {
        "value": "headwear_hijab-white",
        "displayName": "Hijab White",
        "description": {
          "Type": "hijab",
          "Color": "white"
        },
        "morphRelationships": [
          {
            "targetCategoryName": "Head",
            "targetMorphName": "ear rotate back",
            "targetMorphValue": 1
          }
        ],
        "randomizationWeight": 0.05
      },
      {
        "value": "headwear_spokemon-mixed",
        "displayName": "Spokemon Mixed",
        "description": {
          "Type": "spokemon",
          "Color": "mixed"
        },
        "randomizationWeight": 0.1
      },
      {
        "value": "headwear_top-hat-1-black",
        "displayName": "Top Hat 1 Black",
        "description": {
          "Type": "top-hat-1",
          "Color": "black"
        }
      }
    ],
    "description": {
      "Type": {
        "options": [
          null,
          "beach-umbrella",
          "beanie-1",
          "hijab",
          "spokemon",
          "top-hat-1"
        ],
        "isPrimaryOption": true
      },
      "Color": {
        "options": [
          "mixed",
          "red",
          "black",
          "blue",
          "gray",
          "lavender",
          "pink",
          "white"
        ]
      }
    }
  },
  "Eyewear": {
    "parts": [
      {
        "value": null,
        "displayName": "None",
        "excludeFromRandomize": false,
        "randomizationWeight": 20
      },
      {
        "value": "eyewear_aviators1",
        "displayName": "Aviators1"
      },
      {
        "value": "eyewear_cool",
        "displayName": "Cool"
      },
      {
        "value": "eyewear_glam-2",
        "displayName": "Glam 2"
      },
      {
        "value": "eyewear_heart-1-pink",
        "displayName": "Heart 1 Pink"
      },
      {
        "value": "eyewear_metal-1",
        "displayName": "Metal 1"
      },
      {
        "value": "eyewear_punk-2",
        "displayName": "Punk 2"
      },
      {
        "value": "eyewear_sports-red",
        "displayName": "Sports Red"
      },
      {
        "value": "eyewear_wire-frame-1-gold",
        "displayName": "Wire Frame 1 Gold"
      }
    ]
  },
  "Earring": {
    "parts": [
      {
        "value": null,
        "displayName": "None",
        "excludeFromRandomize": false,
        "randomizationWeight": 6
      },
      {
        "value": "earring_hoop-high-left-silver",
        "displayName": "Hoop High Left Silver"
      },
      {
        "value": "earring_hoop-high-right-silver",
        "displayName": "Hoop High Right Silver"
      },
      {
        "value": "earring_hoop-large-both-gold",
        "displayName": "Hoop Large Both Gold",
        "bisectInThumbnail": true
      },
      {
        "value": "earring_hoop-small-both-gold",
        "displayName": "Hoop Small Both Gold",
        "bisectInThumbnail": true
      },
      {
        "value": "earring_studded-hoops-silver",
        "displayName": "Studded Hoops Silver"
      }
    ]
  },
  "Accessory": {
    "parts": [
      {
        "value": null,
        "displayName": "None",
        "excludeFromRandomize": false
      },
      {
        "value": "accessory_duck-floaty",
        "displayName": "Duck Floaty"
      },
      {
        "value": "accessory_face-mask-1-animated",
        "displayName": "Face Mask 1 Animated",
        "randomizationWeight": 0.5
      },
      {
        "value": "accessory_headband-cat-ears-1",
        "displayName": "Headband Cat Ears 1"
      },
      {
        "value": "accessory_headphones-1-black",
        "displayName": "Headphones 1 Black"
      },
      {
        "value": "accessory_pool-mask-1",
        "displayName": "Pool Mask 1",
        "randomizationWeight": 0.1
      }
    ]
  }
};